webpackJsonp([0],{

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ },

/***/ 1:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(React) {'use strict';
	
	var _reactDom = __webpack_require__(158);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _App = __webpack_require__(159);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactDom2.default.render(React.createElement(_App2.default, null), document.getElementById('app'));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ },

/***/ 158:
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(4);


/***/ },

/***/ 159:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(React) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(160);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_React$Component) {
	  _inherits(App, _React$Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	  }
	
	  _createClass(App, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      __webpack_require__(164);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return React.createElement(
	        'div',
	        null,
	        React.createElement(
	          'table',
	          null,
	          React.createElement(
	            'tbody',
	            null,
	            React.createElement(
	              'tr',
	              null,
	              React.createElement(
	                'td',
	                { rowSpan: '6' },
	                React.createElement('canvas', { id: 'b2dCanvas', width: '800', height: '600' })
	              ),
	              React.createElement(
	                'td',
	                null,
	                React.createElement(
	                  'ul',
	                  null,
	                  React.createElement(
	                    'li',
	                    null,
	                    'Right Click in the transparent red area to create an angry bird !!!!'
	                  ),
	                  React.createElement(
	                    'li',
	                    null,
	                    'Click or drag on the ice to cut it!!!!'
	                  ),
	                  React.createElement(
	                    'li',
	                    null,
	                    'Crash into as many as easter bunny as possible!!!'
	                  )
	                )
	              )
	            ),
	            React.createElement(
	              'tr',
	              null,
	              React.createElement(
	                'td',
	                { id: 'levelLabel', style: { font: '20px times new roman, sans serif' } },
	                'LEVEL 1'
	              )
	            ),
	            React.createElement(
	              'tr',
	              null,
	              React.createElement(
	                'td',
	                { id: 'nextLevel' },
	                React.createElement(
	                  'button',
	                  null,
	                  'Next level'
	                )
	              )
	            ),
	            React.createElement(
	              'tr',
	              null,
	              React.createElement(
	                'td',
	                { id: 'restartLevel' },
	                React.createElement(
	                  'button',
	                  null,
	                  'Restart level'
	                )
	              )
	            ),
	            React.createElement(
	              'tr',
	              null,
	              React.createElement('td', null)
	            )
	          )
	        ),
	        React.createElement(
	          'div',
	          { id: 'level-dialog', title: 'Mission Completed!' },
	          'You made it!!!'
	        )
	      );
	    }
	  }]);
	
	  return App;
	}(React.Component);
	
	exports.default = App;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ },

/***/ 160:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },

/***/ 164:
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var ResourceLoader = __webpack_require__(165);
	var Physics = __webpack_require__(166);
	var Body = __webpack_require__(167);
	var levelLoader = __webpack_require__(179);
	
	/*
	 * Global variable dependency: _levelLoader
	 */
	
	//Import Box2D constructors
	var b2Vec2 = Box2D.Common.Math.b2Vec2;
	var b2BodyDef = Box2D.Dynamics.b2BodyDef;
	var b2Body = Box2D.Dynamics.b2Body;
	var b2FixtureDef = Box2D.Dynamics.b2FixtureDef;
	var b2Fixture = Box2D.Dynamics.b2Fixture;
	var b2World = Box2D.Dynamics.b2World;
	var b2MassData = Box2D.Collision.Shapes.b2MassData;
	var b2PolygonShape = Box2D.Collision.Shapes.b2PolygonShape;
	var b2CircleShape = Box2D.Collision.Shapes.b2CircleShape;
	var b2DebugDraw = Box2D.Dynamics.b2DebugDraw;
	var b2Transform = Box2D.Common.Math.b2Transform;
	var b2Mat22 = Box2D.Common.Math.b2Mat22;
	var b2RevoluteJointDef = Box2D.Dynamics.Joints.b2RevoluteJointDef;
	var b2PrismaticJointDef = Box2D.Dynamics.Joints.b2PrismaticJointDef;
	
	var CONSTANTS = {
		WALL_ID: "wall",
		START_POINT_ID: "startBox",
		LEFT_WALL_ID: "leftWall",
		RIGHT_WALL_ID: "rightWall",
		BALL_R: 15,
		BALL_ID: "egg",
		BUNNY_R: 20
	};
	
	//Global Game Constants
	var WALL_ID = CONSTANTS.WALL_ID;
	var START_POINT_ID = CONSTANTS.START_POINT_ID;
	var LEFT_WALL_ID = CONSTANTS.LEFT_WALL_ID;
	var RIGHT_WALL_ID = CONSTANTS.RIGHT_WALL_ID;
	var BALL_R = CONSTANTS.BALL_R;
	var BALL_ID = CONSTANTS.BALL_ID;
	var BUNNY_R = CONSTANTS.BUNNY_R;
	
	// Global Game Variables
	
	var __globals = {
		_terrain: null,
		_resources: null,
		_canvasW: null,
		_canvasH: null,
		CONSTANTS: CONSTANTS
	};
	
	// var _terrain;
	var _resources;
	var _levelLoader;
	var _levelPos = 0;
	var _physics,
	    _lastFrame = new Date().getTime();
	// var _canvasW, _canvasH;
	
	var resourceList = [{
		name: "ballImg",
		type: "image",
		url: __webpack_require__(180)
	}, {
		name: "bunnyImg",
		type: "image",
		url: __webpack_require__(181)
	}, {
		name: "snowPattern",
		type: "image",
		url: __webpack_require__(182)
	}];
	
	window.onerror = function (error) {
		alert(error);
	};
	
	window.gameLoop = function () {
		var tm = new Date().getTime();
		requestAnimationFrame(gameLoop);
		var dt = (tm - _lastFrame) / 1000;
		if (dt > 1 / 15) {
			dt = 1 / 15;
		}
		_physics.step(dt);
		_lastFrame = tm;
	};
	
	function init() {
	
		var resLoader = new ResourceLoader(resourceList, function (loaded) {
	
			__globals._resources = loaded;
			_resources = __globals._resources;
	
			var canvas = document.getElementById("b2dCanvas");
			_physics = new Physics(canvas, null, __globals);
			__globals._canvasW = canvas.width;
			__globals._canvasH = canvas.height;
			var _canvasW = __globals._canvasW,
			    _canvasH = __globals._canvasH;
			_levelLoader = new levelLoader(_physics, __globals);
	
			// physics.debug();
			_physics.collision();
	
			// ground
			new Body(_physics, {
				id: WALL_ID,
				color: "#e5e5e5",
				type: "static",
				x: _canvasW / 2,
				y: _canvasH + 10,
				height: 40,
				width: _canvasW
			});
	
			// ceiling
			new Body(_physics, {
				id: WALL_ID,
				color: "#e5e5e5",
				type: "static",
				x: _canvasW / 2,
				y: -20,
				height: 40,
				width: _canvasW
			});
	
			// left wall
			new Body(_physics, {
				id: LEFT_WALL_ID,
				color: "red",
				type: "static",
				x: -10,
				y: _canvasH / 2,
				height: _canvasH * 2,
				width: 20
			});
	
			// right wall
			new Body(_physics, {
				id: RIGHT_WALL_ID,
				color: "red",
				type: "static",
				x: _canvasW + 10,
				y: _canvasH / 2,
				height: _canvasH * 2,
				width: 20
			});
	
			_levelLoader.load(_levelPos);
	
			$('#nextLevel').click(function () {
				nextLevel();
			});
	
			$('#restartLevel').click(function () {
				restartLevel();
			});
	
			_physics.rightClickToCreate(function (e) {
				var posX = e.offsetX || e.layerX,
				    posY = e.offsetY || e.layerY;
	
				_physics.world.QueryPoint(function (fixture) {
					var obj = fixture.GetBody().GetUserData();
					if (obj && obj.details.id === START_POINT_ID) {
						new Body(_physics, {
							id: BALL_ID,
							image: _resources.ballImg,
							shape: "circle",
							x: posX,
							y: posY,
							radius: BALL_R,
							width: BALL_R * 2,
							height: BALL_R * 2,
							density: 1,
							friction: 0.5,
							restitution: 0.5,
							life: 1000
						});
					}
				}, {
					x: posX / _physics.scale,
					y: posY / _physics.scale
				});
	
				// if (isPointInBox({
				// x : posX,
				// y : posY
				// }, _box)) {
				// new Body(_physics, {
				// id : BALL_ID,
				// image : _resources.ballImg,
				// shape : "circle",
				// x : posX,
				// y : posY,
				// radius : BALL_R,
				// width : BALL_R * 2,
				// height : BALL_R * 2,
				// density : 1,
				// friction : 0.5,
				// restitution : 0.5
				// });
				// }
	
				// Prevent the click event to be triggered
				return false;
			});
	
			$("#level-dialog").dialog({
				autoOpen: false,
				resizable: false,
				height: 200,
				modal: true,
				buttons: {
					"Go to next": function GoToNext() {
						nextLevel();
						$(this).dialog("close");
					},
					Cancel: function Cancel() {
						$(this).dialog("close");
					}
				}
			});
	
			_physics.onMouseDown(function (e) {
				_physics.element.addEventListener("mousemove", doExplosion);
			});
	
			_physics.onMouseUp(function (e) {
				_physics.element.removeEventListener("mousemove", doExplosion);
			});
	
			if (touchable()) {
				_physics.onTouchStart(function (e) {
					if (e.touches.length === 1) _physics.element.addEventListener("touchmove", doExplosion);
				});
	
				_physics.onTouchEnd(function (e) {
					if (e.touches.length === 1) _physics.element.removeEventListener("touchmove", doExplosion);
				});
			}
	
			_physics.onClick(doExplosion);
	
			requestAnimationFrame(gameLoop);
		});
	
		resLoader.load();
	}
	
	window.addEventListener("load", init);
	
	function nextLevel() {
		resetWorld();
		_levelLoader.load(++_levelPos % _levelLoader.levels.length);
		$('#levelLabel').html("LEVEL " + (_levelPos % _levelLoader.levels.length + 1));
	}
	
	function restartLevel() {
		resetWorld();
		_levelLoader.load(_levelPos % _levelLoader.levels.length);
	}
	
	function isPointInBox(point, box) {
		var xMin, xMax, yMin, yMax;
	
		var pointA = box[0];
		var pointB = box[1];
		var pointC = box[2];
	
		var p1 = pointA,
		    p2 = pointB,
		    p3 = pointC;
		if (pointA.x !== pointB.x) {
			p2 = pointC;
			p3 = pointB;
		}
	
		yMin = p1.y;
		yMax = p2.y;
		if (p1.y > p2.y) {
			yMin = p2.y;
			yMax = p1.y;
		}
		xMin = p1.x;
		xMax = p3.x;
		if (p1.x > p3.x) {
			xMin = p3.x;
			xMAx = p1.x;
		}
	
		return point.x > xMin && point.x < xMax && point.y > yMin && point.y < yMax;
	}
	
	function touchable() {
		return 'createTouch' in document;
	}
	
	function resetWorld() {
		var body = _physics.world.GetBodyList();
	
		while (body) {
			var obj = body.GetUserData();
	
			if (obj) {
				var id = obj.details.id;
				if (!id || id && !(id === WALL_ID || id === LEFT_WALL_ID || id === RIGHT_WALL_ID)) {
					obj.details.dead = true;
				}
			}
			body = body.GetNext();
		}
	
		__globals._terrain = null;
	}
	
	/*
	 * This is core function for enabling destructible terrain Reference:
	 * http://www.emanueleferonato.com/2013/10/17/how-to-create-destructible-terrain-using-box2d-step-2/
	 * polygon winding order for clipper (outer == CW; holes == CCW)
	 */
	function doExplosion(e) {
		e.preventDefault();
	
		var _terrain = __globals._terrain;
	
		if (!_terrain) return;
	
		var self = _physics;
	
		var pos = {
			x: e.offsetX || e.layerX,
			y: e.offsetY || e.layerY
		};
	
		var explosionPolygon = createCircle(20, pos, 30);
	
		var polys = transformKey(_terrain.details.terrainPolys, true);
	
		for (var i in polys) {
			var poly = polys[i];
			poly.holes.push(explosionPolygon);
		}
	
		var tempPolys = [];
		for (var i in polys) {
			var poly = polys[i];
	
			var subjPolygons = [poly.outer];
	
			var clipPolygons = poly.holes;
	
			var polytree = new ClipperLib.PolyTree();
	
			var clipType = ClipperLib.ClipType.ctDifference;
			var subjectFillType = ClipperLib.PolyFillType.pftNonZero;
			var clipFillType = ClipperLib.PolyFillType.pftNonZero;
	
			var cpr = new ClipperLib.Clipper();
			cpr.AddPaths(subjPolygons, ClipperLib.PolyType.ptSubject, true);
			cpr.AddPaths(clipPolygons, ClipperLib.PolyType.ptClip, true);
			var succeeded = cpr.Execute(clipType, polytree, subjectFillType, clipFillType);
	
			// console.log(succeeded);
	
			if (!succeeded) {
				throw Error("Clipping failed...");
			}
	
			var solutionPolygons = ClipperLib.JS.PolyTreeToExPolygons(polytree);
	
			tempPolys = tempPolys.concat(solutionPolygons || []);
		}
	
		for (var i = 0; i < tempPolys.length; i++) {
			var lightenTolerance = 0.01;
			var cleanTolerance = 0.01;
	
			// for clipper 6.0 not doing the following steps seems to increase the performance
	
			// tempPolys[i].outer = ClipperLib.Clipper.CleanPolygon(tempPolys[i].outer,
			// 		cleanTolerance * self.scale);
			// tempPolys[i].outer = ClipperLib.JS.Lighten(tempPolys[i].outer,
			// 		lightenTolerance * self.scale)[0];
			//
			// tempPolys[i].holes = ClipperLib.JS.Lighten(tempPolys[i].holes,
			// 		lightenTolerance * self.scale);
			// tempPolys[i].holes = ClipperLib.Clipper.CleanPolygons(tempPolys[i].holes,
			// 		cleanTolerance * self.scale);
		}
	
		self.world.DestroyBody(_terrain.body);
		__globals._terrain = new Body(_physics, {
			type: "static",
			shape: "terrain",
			patternImg: _resources.snowPattern,
			terrainPolys: transformKey(tempPolys)
		});
	};
	
	function transformKey(polys, lowerToUpper) {
		return polys.map(function (poly) {
			return {
				outer: transformPoly(poly.outer, lowerToUpper),
				holes: poly.holes.map(function (hole) {
					return transformPoly(hole, lowerToUpper);
				})
			};
		});
	}
	
	function transformPoly(poly, lowerToUpper) {
		var resultPoly = [];
	
		for (var j = 0; j < poly.length; j++) {
			var vertex = poly[j];
	
			if (lowerToUpper) {
				resultPoly.push({
					X: vertex.x,
					Y: vertex.y
				});
			} else {
				resultPoly.push({
					x: vertex.X,
					y: vertex.Y
				});
			}
		}
	
		return resultPoly;
	}
	
	function createCircle(precision, origin, radius) {
		var angle = 2 * Math.PI / precision;
		var circleArray = [];
		for (var i = 0; i < precision; i++) {
			circleArray.push({
				X: origin.x + radius * Math.cos(angle * i),
				Y: origin.y + radius * Math.sin(angle * i)
			});
		}
		return circleArray.reverse();
	}
	
	// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
	// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating
	
	// requestAnimationFrame polyfill by Erik Möller
	// fixes from Paul Irish and Tino Zijdel
	
	(function () {
		var lastTime = 0;
		var vendors = ['ms', 'moz', 'webkit', 'o'];
		for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
			window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
			window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
		}
	
		if (!window.requestAnimationFrame) {
			window.requestAnimationFrame = function (callback, element) {
				var currTime = new Date().getTime();
				var timeToCall = Math.max(0, 16 - (currTime - lastTime));
				var id = window.setTimeout(function () {
					callback(currTime + timeToCall);
				}, timeToCall);
				lastTime = currTime + timeToCall;
				return id;
			};
		}
	
		if (!window.cancelAnimationFrame) {
			window.cancelAnimationFrame = function (id) {
				clearTimeout(id);
			};
		}
	})();

/***/ },

/***/ 165:
/***/ function(module, exports) {

	"use strict";
	
	(function (window) {
		function ResourceLoader(objList, callback) {
			this.objList = objList;
			this.onload = callback;
			this.resources = {};
			this.loadCount = 0;
		}
	
		ResourceLoader.prototype.loadResource = function (name, type, url) {
	
			var loader = this;
			var res;
			switch (type) {
				case "audio":
					res = new Audio();
					break;
				case "image":
					res = new Image();
					break;
				default:
					;
			}
	
			res.src = url;
	
			res.onload = function () {
	
				loader.resources[name] = res;
	
				if (++loader.loadCount == loader.objList.length) loader.onload(loader.resources);
			};
		};
	
		ResourceLoader.prototype.load = function () {
			for (var i = 0; i < this.objList.length; ++i) {
				var obj = this.objList[i];
				this.loadResource(obj.name, obj.type, obj.url);
			}
		};
	
		window.ResourceLoader = ResourceLoader;
	
		module.exports = ResourceLoader;
	})(window);

/***/ },

/***/ 166:
/***/ function(module, exports) {

	"use strict";
	
	/**
	 *
	 */
	
	(function (window) {
	
		var b2Vec2 = Box2D.Common.Math.b2Vec2;
		var b2World = Box2D.Dynamics.b2World;
	
		var GRAVITY = 30;
		var BRUSH_R = 15;
	
		function Physics(element, scale, __globals) {
			this.resources = __globals._resources;
	
			var gravity = new b2Vec2(0, GRAVITY);
			this.world = new b2World(gravity, true);
			this.element = element; // most likely the canvas element
			this.context = element.getContext("2d");
			this.scale = scale || 30;
			this.dtRemaining = 0;
			this.stepAmount = 1 / 60;
		}
	
		Physics.prototype.step = function (dt) {
			this.dtRemaining += dt;
			while (this.dtRemaining > this.stepAmount) {
				this.dtRemaining -= this.stepAmount;
				this.world.Step(this.stepAmount, 8, 3);
			}
	
			var body = this.world.GetBodyList();
	
			if (this.debugDraw) {
				this.world.DrawDebugData();
			} else {
				this.context.clearRect(0, 0, this.element.width, this.element.height);
			}
	
			var deadBodies = [];
	
			var drawLater = [];
	
			while (body) {
				var obj = body.GetUserData();
				if (obj) {
					obj.update();
					if (obj.details.dead) deadBodies.push(body);
					if (!this.debugDraw) {
						if (obj.details.zIndex > 0) {
							drawLater.push(obj);
						} else {
							obj.draw(this.context);
						}
					}
				}
	
				body = body.GetNext();
			}
	
			for (var i in drawLater) {
				drawLater[i].draw(this.context);
			}
	
			// Remove dead bodies
			for (var i = 0; i < deadBodies.length; i++) {
				this.world.DestroyBody(deadBodies[i]);
			}
		};
	
		Physics.prototype.debug = function () {
			this.debugDraw = new b2DebugDraw();
			this.debugDraw.SetSprite(this.context);
			this.debugDraw.SetDrawScale(this.scale);
			this.debugDraw.SetFillAlpha(0.3);
			this.debugDraw.SetLineThickness(1.0);
			this.debugDraw.SetFlags(b2DebugDraw.e_shapeBit | b2DebugDraw.e_jointBit);
			this.world.SetDebugDraw(this.debugDraw);
		};
	
		Physics.prototype.onMouseDown = function (callback) {
	
			function handleMouseDown(e) {
				e.preventDefault();
				callback(e);
			}
	
			this.element.addEventListener("mousedown", handleMouseDown);
		};
	
		Physics.prototype.onMouseUp = function (callback) {
	
			function handleMouseUp(e) {
				e.preventDefault();
				callback(e);
			}
	
			this.element.addEventListener("mouseup", handleMouseUp);
		};
	
		Physics.prototype.onClick = function (callback) {
	
			function handleClick(e) {
				e.preventDefault();
				callback(e);
			}
	
			this.element.addEventListener("click", handleClick);
		};
	
		Physics.prototype.rightClickToCreate = function (callback) {
	
			function handleRightClick(e) {
				e.preventDefault();
				callback(e);
			}
	
			this.element.addEventListener("contextmenu", handleRightClick);
		};
	
		Physics.prototype.onTouchEnd = function (callback) {
	
			function handleTouchEnd(e) {
				e.preventDefault();
				callback(e);
			}
	
			this.element.addEventListener("touchend", handleTouchEnd);
		};
	
		Physics.prototype.onTouchStart = function (callback) {
	
			function handleTouchStart(e) {
				e.preventDefault();
				callback(e);
			}
	
			this.element.addEventListener("touchstart", handleTouchStart);
		};
	
		Physics.prototype.collision = function () {
			this.listener = new Box2D.Dynamics.b2ContactListener();
			this.listener.BeginContact = function (contact) {
				var bodyA = contact.GetFixtureA().GetBody().GetUserData(),
				    bodyB = contact.GetFixtureB().GetBody().GetUserData();
	
				if (bodyA.beginContact) {
					bodyA.beginContact(bodyB);
				}
				if (bodyB.beginContact) {
					bodyB.beginContact(bodyA);
				}
			};
			this.listener.EndContact = function (contact) {
				var bodyA = contact.GetFixtureA().GetBody().GetUserData(),
				    bodyB = contact.GetFixtureB().GetBody().GetUserData();
	
				if (bodyA.endContact) {
					bodyA.endContact(bodyB);
				}
				if (bodyB.endContact) {
					bodyB.endContact(bodyA);
				}
			};
	
			this.listener.PostSolve = function (contact, impulse) {
				var bodyA = contact.GetFixtureA().GetBody().GetUserData(),
				    bodyB = contact.GetFixtureB().GetBody().GetUserData();
	
				if (bodyA.postSolve) {
					bodyA.postSolve(contact, impulse);
				}
				if (bodyB.postSolve) {
					bodyB.postSolve(contact, impulse);
				}
			};
			this.world.SetContactListener(this.listener);
		};
	
		window.Physics = Physics;
	
		module.exports = Physics;
	})(window);

/***/ },

/***/ 167:
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(poly2tri) {"use strict";
	
	/**
	 *
	 */
	(function (window) {
	
		//Import Box2D constructors
		var b2Vec2 = Box2D.Common.Math.b2Vec2;
		var b2BodyDef = Box2D.Dynamics.b2BodyDef;
		var b2Body = Box2D.Dynamics.b2Body;
		var b2FixtureDef = Box2D.Dynamics.b2FixtureDef;
		var b2Fixture = Box2D.Dynamics.b2Fixture;
		var b2World = Box2D.Dynamics.b2World;
		var b2MassData = Box2D.Collision.Shapes.b2MassData;
		var b2PolygonShape = Box2D.Collision.Shapes.b2PolygonShape;
		var b2CircleShape = Box2D.Collision.Shapes.b2CircleShape;
		var b2DebugDraw = Box2D.Dynamics.b2DebugDraw;
		var b2Transform = Box2D.Common.Math.b2Transform;
		var b2Mat22 = Box2D.Common.Math.b2Mat22;
		var b2RevoluteJointDef = Box2D.Dynamics.Joints.b2RevoluteJointDef;
		var b2PrismaticJointDef = Box2D.Dynamics.Joints.b2PrismaticJointDef;
	
		function Body(physics, details) {
			this.details = details = details || {};
	
			// Create the definition
			this.definition = new b2BodyDef();
	
			// Set up the definition
			for (var k in this.definitionDefaults) {
				this.definition[k] = details[k] || this.definitionDefaults[k];
			}
			this.definition.position = new b2Vec2(details.x / physics.scale || 0, details.y / physics.scale || 0);
			this.definition.linearVelocity = new b2Vec2(details.vx / physics.scale || 0, details.vy / physics.scale || 0);
			this.definition.userData = this;
			this.definition.type = details.type == "static" ? b2Body.b2_staticBody : b2Body.b2_dynamicBody;
	
			// Create the Body
			this.body = physics.world.CreateBody(this.definition);
	
			// Create the fixture
			this.fixtureDef = new b2FixtureDef();
			for (var l in this.fixtureDefaults) {
				this.fixtureDef[l] = details[l] || this.fixtureDefaults[l];
			}
	
			for (var k in this.defaults) {
				this.details[k] = details[k] || this.defaults[k];
			}
	
			switch (details.shape) {
				case "circle":
					details.radius = details.radius || this.defaults.radius;
					this.fixtureDef.shape = new b2CircleShape(details.radius / physics.scale);
					break;
				case "polygon":
					break;
				case "terrain":
					break;
				case "block":
				default:
					details.width = details.width || this.defaults.width;
					details.height = details.height || this.defaults.height;
	
					this.fixtureDef.shape = new b2PolygonShape();
					this.fixtureDef.shape.SetAsBox(details.width / 2 / physics.scale, details.height / 2 / physics.scale);
					break;
			}
	
			if (details.shape === "polygon") {
	
				var triContext = new poly2tri.SweepContext(details.points, {
					cloneArrays: true
				});
	
				triContext.triangulate();
				var triangles = triContext.getTriangles();
				for (var i in triangles) {
					var verticesVec = [];
					for (var j in triangles[i].points_) {
						var point = triangles[i].points_[j];
						verticesVec.push({
							x: point.x / physics.scale,
							y: point.y / physics.scale
						});
					}
					var polyShape = new b2PolygonShape();
					polyShape.SetAsVector(verticesVec);
					this.fixtureDef.shape = polyShape;
					var fixture = this.body.CreateFixture(this.fixtureDef);
					if (details.isSensor) fixture.SetSensor(details.isSensor);
				}
			} else if (details.shape === "terrain") {
				var terrainTriangles = [];
				for (var i = 0; i < details.terrainPolys.length; i++) {
					var poly = details.terrainPolys[i];
	
					if (!poly.outer) continue;
	
					var triContext = new poly2tri.SweepContext(poly.outer, {
						cloneArrays: true
					});
					for (var j in poly.holes) {
						triContext.addHole(poly.holes[j]);
					}
	
					try {
						triContext.triangulate();
					} catch (e) {
	
						console.log("I got this fixed!");
	
						var delta = 0.0001;
						var offsetted = [];
						for (var k in poly.outer) {
							offsetted.push({
								x: poly.outer[k].x + (Math.random() > 0.5 ? 1 : -1) * delta * k,
								y: poly.outer[k].y + (Math.random() > 0.5 ? 1 : -1) * delta * k
							});
						}
	
						triContext = new poly2tri.SweepContext(offsetted, {
							cloneArrays: true
						});
						for (var n in poly.holes) {
							triContext.addHole(poly.holes[n]);
						}
	
						triContext.triangulate();
					}
					terrainTriangles = terrainTriangles.concat(triContext.getTriangles() || []);
				}
	
				for (var i in terrainTriangles) {
					var verticesVec = [];
					for (var j in terrainTriangles[i].points_) {
						var point = terrainTriangles[i].points_[j];
						verticesVec.push({
							x: point.x / physics.scale,
							y: point.y / physics.scale
						});
					}
					polyShape = new b2PolygonShape();
					polyShape.SetAsVector(verticesVec);
					this.fixtureDef.shape = polyShape;
					this.body.CreateFixture(this.fixtureDef);
				}
			} else {
				var fixture = this.body.CreateFixture(this.fixtureDef);
				if (details.isSensor) fixture.SetSensor(details.isSensor);
			}
	
			this.update = function () {
				details.life--;
				if (details.life < 0) {
					details.dead = true;
				}
			};
	
			this.draw = function (context) {
				var pos = this.body.GetPosition(),
				    angle = this.body.GetAngle();
	
				context.save();
				context.translate(pos.x * physics.scale, pos.y * physics.scale);
				context.rotate(angle);
	
				if (this.details.color || this.details.patternImg) {
					context.fillStyle = this.details.color;
	
					switch (this.details.shape) {
						case "circle":
							context.beginPath();
							context.arc(0, 0, this.details.radius, 0, Math.PI * 2);
							context.fill();
							break;
						case "polygon":
							var points = this.details.points;
							context.beginPath();
							context.moveTo(points[0].x, points[0].y);
							for (var i = 1; i < points.length; i++) {
								context.lineTo(points[i].x, points[i].y);
							}
							context.fill();
							break;
						case "terrain":
	
							if (this.details.patternImg) {
								var pattern = context.createPattern(this.details.patternImg, "repeat");
								context.fillStyle = pattern;
							}
	
							for (var k in this.details.terrainPolys) {
								var poly = this.details.terrainPolys[k];
	
								if (!poly.outer) continue;
	
								context.beginPath();
								context.moveTo(poly.outer[0].x, poly.outer[0].y);
								for (var i = 1; i < poly.outer.length; i++) {
									context.lineTo(poly.outer[i].x, poly.outer[i].y);
								}
								context.closePath();
								context.fill();
							}
	
							for (var k in this.details.terrainPolys) {
								var poly = this.details.terrainPolys[k];
	
								context.fillStyle = "black";
								var holes = poly.holes;
								for (var i in holes) {
									var hole = holes[i];
									context.beginPath();
									context.moveTo(hole[0].x, hole[0].y);
									for (var j = 1; j < hole.length; j++) {
										context.lineTo(hole[j].x, hole[j].y);
									}
									context.fill();
								}
							}
	
							break;
						case "block":
							context.fillRect(-this.details.width / 2, -this.details.height / 2, this.details.width, this.details.height);
						default:
							break;
					}
				}
	
				if (this.details.image) {
					context.drawImage(this.details.image, -this.details.width / 2, -this.details.height / 2, this.details.width, this.details.height);
				}
	
				context.restore();
			};
		}
	
		window.Body = Body;
	
		Body.prototype.defaults = {
			shape: "block",
			width: 120,
			height: 120,
			radius: 30,
			life: Infinity,
			dead: false,
			zIndex: 0
		};
	
		Body.prototype.fixtureDefaults = {
			density: 2,
			friction: 1,
			restitution: 0.2
		};
	
		Body.prototype.definitionDefaults = {
			active: true,
			allowSleep: true,
			angle: 0,
			angularVelocity: 0,
			awake: true,
			bullet: false,
			fixedRotation: false
		};
	
		module.exports = Body;
	})(window);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(168)))

/***/ },

/***/ 179:
/***/ function(module, exports) {

	"use strict";
	
	/*
	 *
	 * Constants dependencies: BALL_ID, BUNNY_ID, BUNNY_R,
	 * LEFT_WALL_ID, RIGHT_WALL_ID, WALL_ID, START_BOX_ID
	 * Global variable dependencies: _physics, _terrain, _resources,
	 * _canvasW, _canvasH
	 */
	
	//TODO Try to reduce dependencies
	//TODO refactor code
	
	
	(function () {
	
		var b2Vec2 = Box2D.Common.Math.b2Vec2;
		var b2RevoluteJointDef = Box2D.Dynamics.Joints.b2RevoluteJointDef;
		var b2PrismaticJointDef = Box2D.Dynamics.Joints.b2PrismaticJointDef;
	
		function levelLoader(_physics, __globals) {
	
			var WALL_ID = __globals.CONSTANTS.WALL_ID;
			var START_POINT_ID = __globals.CONSTANTS.START_POINT_ID;
			var LEFT_WALL_ID = __globals.CONSTANTS.LEFT_WALL_ID;
			var RIGHT_WALL_ID = __globals.CONSTANTS.RIGHT_WALL_ID;
			var BALL_R = __globals.CONSTANTS.BALL_R;
			var BALL_ID = __globals.CONSTANTS.BALL_ID;
			var BUNNY_R = __globals.CONSTANTS.BUNNY_R;
	
			var _resources = __globals._resources;
			var _canvasW = __globals._canvasW;
			var _canvasH = __globals._canvasH;
	
			var levels = [levelOne, levelTwo, levelThree, levelFour, levelFive, levelSix, levelSeven, levelEight, levelNine];
	
			function levelOne() {
	
				createStartPoint({
					"x": 0.5537500381469727,
					"y": 0.6912499666213989
				}, 0.09500002861022949);
	
				createTerrain([{
					outer: [{
						"x": 0.001249939203262329,
						"y": 0.7137500047683716
					}, {
						"x": 0.32624995708465576,
						"y": 0.6137499809265137
					}, {
						"x": 0.47624993324279785,
						"y": 0.5887500047683716
					}, {
						"x": 0.5762499570846558,
						"y": 0.5387499928474426
					}, {
						"x": 0.6512500047683716,
						"y": 0.5887500047683716
					}, {
						"x": 1.00124990940094,
						"y": 0.6887499690055847
					}, {
						"x": 1.00124990940094,
						"y": 0.18874996900558472
					}, {
						"x": 0.001249939203262329,
						"y": 0.18874996900558472
					}],
					holes: [[{
						"x": 0.37624993920326233,
						"y": 0.5137499570846558
					}, {
						"x": 0.37624993920326233,
						"y": 0.4637500047683716
					}, {
						"x": 0.4262499511241913,
						"y": 0.4637500047683716
					}, {
						"x": 0.4262499511241913,
						"y": 0.5137499570846558
					}], [{
						"x": 0.6012499332427979,
						"y": 0.38874995708465576
					}, {
						"x": 0.6012499332427979,
						"y": 0.4387499690055847
					}, {
						"x": 0.6512500047683716,
						"y": 0.4387499690055847
					}, {
						"x": 0.6512500047683716,
						"y": 0.38874995708465576
					}], [{
						"x": 0.47624993324279785,
						"y": 0.3137499690055847
					}, {
						"x": 0.47624993324279785,
						"y": 0.26374995708465576
					}, {
						"x": 0.5262500047683716,
						"y": 0.26374995708465576
					}, {
						"x": 0.5262500047683716,
						"y": 0.3137499690055847
					}]]
				}]);
	
				createSensors([{
					"x": 0.4012499451637268,
					"y": 0.48874998092651367
				}, {
					"x": 0.6262499094009399,
					"y": 0.4137499928474426
				}, {
					"x": 0.5012499094009399,
					"y": 0.28874996304512024
				}]);
	
				createDestination([{
					"x": 0.42500001192092896,
					"y": 0
				}, {
					"x": 0.42500001192092896,
					"y": 0.02500000037252903
				}, {
					"x": 0.550000011920929,
					"y": 0.02500000037252903
				}, {
					"x": 0.550000011920929,
					"y": 0
				}]);
			}
	
			function levelTwo() {
	
				createStartPoint({
					"x": 0.11624997854232788,
					"y": 0.6937499642372131
				}, 0.08933781832456589);
	
				createTerrain([{
					outer: [{
						"x": 0,
						"y": 0.550000011920929
					}, {
						"x": 0.32500001788139343,
						"y": 0.6500000357627869
					}, {
						"x": 0.6000000238418579,
						"y": 0.625
					}, {
						"x": 0.875,
						"y": 0.625
					}, {
						"x": 0.9750000238418579,
						"y": 0.4749999940395355
					}, {
						"x": 0.8500000238418579,
						"y": 0.25
					}, {
						"x": 0.625,
						"y": 0.17499999701976776
					}, {
						"x": 0.2750000059604645,
						"y": 0.20000000298023224
					}, {
						"x": 0,
						"y": 0.2750000059604645
					}],
					holes: [[{
						"x": 0.45000001788139343,
						"y": 0.2750000059604645
					}, {
						"x": 0.45000001788139343,
						"y": 0.22500000894069672
					}, {
						"x": 0.5,
						"y": 0.22500000894069672
					}, {
						"x": 0.5,
						"y": 0.2750000059604645
					}], [{
						"x": 0.25,
						"y": 0.574999988079071
					}, {
						"x": 0.25,
						"y": 0.5250000357627869
					}, {
						"x": 0.30000001192092896,
						"y": 0.5250000357627869
					}, {
						"x": 0.30000001192092896,
						"y": 0.574999988079071
					}], [{
						"x": 0.824999988079071,
						"y": 0.5250000357627869
					}, {
						"x": 0.824999988079071,
						"y": 0.4749999940395355
					}, {
						"x": 0.875,
						"y": 0.4749999940395355
					}, {
						"x": 0.875,
						"y": 0.5250000357627869
					}]]
				}]);
	
				// create a wall
	
				createWalls([[{
					"x": 0.22500000894069672,
					"y": 0.45000001788139343
				}, {
					"x": 0.675000011920929,
					"y": 0.45000001788139343
				}, {
					"x": 0.7875000238418579,
					"y": 0.4000000059604645
				}, {
					"x": 0.4749999940395355,
					"y": 0.42500001192092896
				}, {
					"x": 0.16249997913837433,
					"y": 0.4000000059604645
				}]]);
	
				createSensors([{
					"x": 0.2750000059604645,
					"y": 0.550000011920929
				}, {
					"x": 0.8500000238418579,
					"y": 0.5
				}, {
					"x": 0.4749999940395355,
					"y": 0.25
				}]);
	
				createDestination([{
					"x": 0.4000000059604645,
					"y": 0.02500000037252903
				}, {
					"x": 0.4000000059604645,
					"y": 0
				}, {
					"x": 0.550000011920929,
					"y": 0
				}, {
					"x": 0.550000011920929,
					"y": 0.02500000037252903
				}]);
			}
	
			function levelThree() {
	
				createStartPoint({
					"x": 0.8612500429153442,
					"y": 0.7162500023841858
				}, 0.06543124467134476);
	
				createTerrain([{
					outer: [{
						"x": 0.925000011920929,
						"y": 0.675000011920929
					}, {
						"x": -0.05000000074505806,
						"y": 0.625
					}, {
						"x": 0.05000000074505806,
						"y": 0.42500001192092896
					}, {
						"x": 0.925000011920929,
						"y": 0.4749999940395355
					}],
					holes: [[{
						"x": 0.05000000074505806,
						"y": 0.574999988079071
					}, {
						"x": 0.05000000074505806,
						"y": 0.5250000357627869
					}, {
						"x": 0.10000000149011612,
						"y": 0.5250000357627869
					}, {
						"x": 0.10000000149011612,
						"y": 0.574999988079071
					}]]
				}, {
					outer: [{
						"x": 0.05000000074505806,
						"y": 0.2750000059604645
					}, {
						"x": 0.05000000074505806,
						"y": 0.10000000149011612
					}, {
						"x": 0.4000000059604645,
						"y": 0.07500000298023224
					}, {
						"x": 0.3499999940395355,
						"y": 0.3499999940395355
					}],
					holes: []
				}]);
	
				createWalls([[{
					"x": 0.45000001788139343,
					"y": 0.22500000894069672
				}, {
					"x": 0.699999988079071,
					"y": 0.15000000596046448
				}, {
					"x": 0.699999988079071,
					"y": 0
				}, {
					"x": 0.75,
					"y": 0
				}, {
					"x": 0.75,
					"y": 0.20000000298023224
				}], [{
					"x": 0.949999988079071,
					"y": 0.42500001192092896
				}, {
					"x": 0.22500000894069672,
					"y": 0.4000000059604645
				}, {
					"x": 0.949999988079071,
					"y": 0.3499999940395355
				}]]);
	
				createSensors([{
					"x": 0.07500000298023224,
					"y": 0.550000011920929
				}, {
					"x": 0.125,
					"y": 0.375
				}, {
					"x": 0.5,
					"y": 0.30000001192092896
				}]);
	
				createDestination([{
					"x": 0.800000011920929,
					"y": 0.02500000037252903
				}, {
					"x": 0.800000011920929,
					"y": 0
				}, {
					"x": 0.9000000357627869,
					"y": 0
				}, {
					"x": 0.9000000357627869,
					"y": 0.02500000037252903
				}]);
			}
	
			function levelFour() {
	
				createStartPoint({
					"x": 0.14874997735023499,
					"y": 0.7212499976158142
				}, 0.08746424317359924);
	
				createTerrain([{
					outer: [{
						"x": -0.0012500286102294922,
						"y": 0.7162500023841858
					}, {
						"x": 0.14874997735023499,
						"y": 0.6687500476837158
					}, {
						"x": 0.32124996185302734,
						"y": 0.7112500071525574
					}, {
						"x": 0.3187500238418579,
						"y": 0.4287499785423279
					}, {
						"x": 0.47874999046325684,
						"y": 0.20624998211860657
					}, {
						"x": 0.001249939203262329,
						"y": 0.2137499749660492
					}],
					holes: [[{
						"x": 0.2750000059604645,
						"y": 0.30000001192092896
					}, {
						"x": 0.2750000059604645,
						"y": 0.25
					}, {
						"x": 0.32500001788139343,
						"y": 0.25
					}, {
						"x": 0.32500001788139343,
						"y": 0.30000001192092896
					}]]
				}, {
					outer: [{
						"x": 0.7250000238418579,
						"y": 0.699999988079071
					}, {
						"x": 0.6500000357627869,
						"y": 0.17499999701976776
					}, {
						"x": 0.949999988079071,
						"y": 0.17499999701976776
					}, {
						"x": 0.949999988079071,
						"y": 0.675000011920929
					}],
					holes: []
				}]);
	
				createWalls([[{
					"x": 0.574999988079071,
					"y": 0.32500001788139343
				}, {
					"x": 0.550000011920929,
					"y": 0
				}, {
					"x": 0.625,
					"y": 0
				}]]);
	
				createSensors([{
					"x": 0.30000001192092896,
					"y": 0.2750000059604645
				}, {
					"x": 0.574999988079071,
					"y": 0.42500001192092896
				}, {
					"x": 0.7250000238418579,
					"y": 0.05000000074505806
				}]);
	
				createDestination([{
					"x": 0.800000011920929,
					"y": 0.02500000037252903
				}, {
					"x": 0.800000011920929,
					"y": 0
				}, {
					"x": 0.9000000357627869,
					"y": 0
				}, {
					"x": 0.9000000357627869,
					"y": 0.02500000037252903
				}]);
			}
	
			function levelFive() {
	
				createStartPoint({
					"x": 0.09874996542930603,
					"y": 0.5537500381469727
				}, 0.12454922497272491);
	
				createTerrain([{
					outer: [{
						"x": -0.1012500524520874,
						"y": 0.4912499785423279
					}, {
						"x": 0.2887499928474426,
						"y": 0.5112499594688416
					}, {
						"x": 0.3037499785423279,
						"y": 0.1887499988079071
					}, {
						"x": -0.07625001668930054,
						"y": 0.19374996423721313
					}],
					holes: []
				}]);
	
				createBouncers([[{
					"x": 0.25,
					"y": 0
				}, {
					"x": 0.25,
					"y": 0.02500000037252903
				}, {
					"x": 0.32500001788139343,
					"y": 0.02500000037252903
				}, {
					"x": 0.32500001788139343,
					"y": 0
				}], [{
					"x": 0.375,
					"y": 0.6000000238418579
				}, {
					"x": 0.375,
					"y": 0.550000011920929
				}, {
					"x": 0.550000011920929,
					"y": 0.6000000238418579
				}, {
					"x": 0.550000011920929,
					"y": 0.6500000357627869
				}], [{
					"x": 0.574999988079071,
					"y": 0
				}, {
					"x": 0.5750000476837158,
					"y": 0.02500000037252903
				}, {
					"x": 0.6500000357627869,
					"y": 0.02500000037252903
				}, {
					"x": 0.6500000357627869,
					"y": 0
				}], [{
					"x": 0.800000011920929,
					"y": 0.375
				}, {
					"x": 0.800000011920929,
					"y": 0.32500001788139343
				}, {
					"x": 1.0162501335144043,
					"y": 0.32625001668930054
				}, {
					"x": 1.0162501335144043,
					"y": 0.3762499988079071
				}]], 1.2);
	
				createSensors([{
					"x": 0.3499999940395355,
					"y": 0.32500001788139343
				}, {
					"x": 0.75,
					"y": 0.4749999940395355
				}, {
					"x": 0.625,
					"y": 0.2750000059604645
				}]);
	
				createDestination([{
					"x": 0.8500000238418579,
					"y": 0.4000000059604645
				}, {
					"x": 0.8500000238418579,
					"y": 0.375
				}, {
					"x": 0.925000011920929,
					"y": 0.375
				}, {
					"x": 0.925000011920929,
					"y": 0.4000000059604645
				}]);
			}
	
			function levelSix() {
	
				createStartPoint({
					"x": 0.13874998688697815,
					"y": 0.6962499618530273
				}, 0.09890014678239822);
	
				createTerrain([{
					outer: [{
						"x": -0.06791657209396362,
						"y": 0.6770836114883423
					}, {
						"x": 0.5291669368743896,
						"y": 0.5366671681404114
					}, {
						"x": 1.032083511352539,
						"y": 0.6070836186408997
					}, {
						"x": 1.024999976158142,
						"y": -0.024999964982271194
					}, {
						"x": -0.05000000074505806,
						"y": -0.05000000074505806
					}],
					holes: [[{
						"x": 0.4845834970474243,
						"y": 0.1420835703611374
					}, {
						"x": 0.5595834851264954,
						"y": 0.2420835793018341
					}, {
						"x": 0.6595834493637085,
						"y": 0.2670835852622986
					}, {
						"x": 0.7095835208892822,
						"y": 0.16708357632160187
					}, {
						"x": 0.6345835328102112,
						"y": 0.09208357334136963
					}, {
						"x": 0.5595834851264954,
						"y": 0.09208357334136963
					}], [{
						"x": 0.8345835208892822,
						"y": 0.16708357632160187
					}, {
						"x": 0.8345835208892822,
						"y": 0.1170835793018341
					}, {
						"x": 0.8845834732055664,
						"y": 0.1170835793018341
					}, {
						"x": 0.8845834732055664,
						"y": 0.16708357632160187
					}], [{
						"x": 0.7595834732055664,
						"y": 0.2420835793018341
					}, {
						"x": 0.7595834732055664,
						"y": 0.19208358228206635
					}, {
						"x": 0.8095834851264954,
						"y": 0.19208358228206635
					}, {
						"x": 0.8095834851264954,
						"y": 0.2420835793018341
					}]]
				}]);
	
				createBouncers([[{
					"x": 0.9645834565162659,
					"y": 0.6920835971832275
				}, {
					"x": 0.9820835590362549,
					"y": 0.6095836162567139
				}, {
					"x": 1.032083511352539,
					"y": 0.6120836138725281
				}, {
					"x": 1.0195834636688232,
					"y": 0.6920835971832275
				}]]);
	
				createWalls([[{
					"x": 0.43458348512649536,
					"y": 0.1420835703611374
				}, {
					"x": 0.45958349108695984,
					"y": 0.1170835793018341
				}, {
					"x": 0.7595834732055664,
					"y": 0.1170835793018341
				}, {
					"x": 0.7595834732055664,
					"y": 0.1420835703611374
				}]]);
	
				createSensors([{
					"x": 0.8695834875106812,
					"y": 0.6120836138725281
				}, {
					"x": 0.7845835089683533,
					"y": 0.21708357334136963
				}, {
					"x": 0.8595834970474243,
					"y": 0.1420835703611374
				}]);
	
				createDestination([{
					"x": 0.5595834851264954,
					"y": 0.16708357632160187
				}, {
					"x": 0.5595834851264954,
					"y": 0.1420835703611374
				}, {
					"x": 0.6345835328102112,
					"y": 0.1420835703611374
				}, {
					"x": 0.6345835328102112,
					"y": 0.16708357632160187
				}]);
			}
	
			function levelSeven() {
	
				createStartPoint({
					"x": 0.8337500691413879,
					"y": 0.7287499904632568
				}, 0.08321647346019745);
	
				createTerrain([{
					outer: [{
						"x": -0.02500000037252903,
						"y": 0.574999988079071
					}, {
						"x": 0.17499999701976776,
						"y": 0.42500001192092896
					}, {
						"x": 0.45000001788139343,
						"y": 0.4000000059604645
					}, {
						"x": 0.4749999940395355,
						"y": 0.125
					}, {
						"x": -0.07500000298023224,
						"y": -0.02500000037252903
					}],
					holes: []
				}, {
					outer: [{
						"x": 0.3499999940395355,
						"y": 0.675000011920929
					}, {
						"x": 0.25,
						"y": 0.574999988079071
					}, {
						"x": 0.9000000357627869,
						"y": 0.5
					}, {
						"x": 0.925000011920929,
						"y": 0.675000011920929
					}],
					holes: []
				}]);
	
				createWalls([[{
					"x": 0.42500001192092896,
					"y": 0
				}, {
					"x": 0.5070834159851074,
					"y": 0.28708362579345703
				}, {
					"x": 0.550000011920929,
					"y": 0
				}], [{
					"x": 0.699999988079071,
					"y": 0
				}, {
					"x": 0.675000011920929,
					"y": 0.2750000059604645
				}, {
					"x": 0.7750000357627869,
					"y": 0
				}], [{
					"x": 0.18083345890045166,
					"y": 0.3008336126804352
				}, {
					"x": 0.19333338737487793,
					"y": 0.2708336114883423
				}, {
					"x": 0.33083340525627136,
					"y": 0.2708336114883423
				}, {
					"x": 0.32333338260650635,
					"y": 0.3008336126804352
				}], [{
					"x": 0.8500000238418579,
					"y": 0.4000000059604645
				}, {
					"x": 0.8500000238418579,
					"y": 0.3499999940395355
				}, {
					"x": 0.9950001239776611,
					"y": 0.3541669249534607
				}, {
					"x": 1.0066670179367065,
					"y": 0.5266672372817993
				}, {
					"x": 0.949999988079071,
					"y": 0.4000000059604645
				}]]);
	
				var board = createPolygon([{
					"x": 0.47500014305114746,
					"y": 0.46250027418136597
				}, {
					"x": 0.49125006794929504,
					"y": 0.2987503111362457
				}, {
					"x": 0.5237500667572021,
					"y": 0.30125030875205994
				}, {
					"x": 0.5066667795181274,
					"y": 0.4725002646446228
				}], {
					color: "green",
					type: "dynamic",
					density: 0.5
				});
	
				createRevoluteJoint(board, {
					"x": 0.5045833587646484,
					"y": 0.3120836615562439
				}, 4);
	
				createPushers([[{
					"x": 0.3499999940395355,
					"y": 0
				}, {
					"x": 0.3499999940395355,
					"y": 0.02500000037252903
				}, {
					"x": 0.42500001192092896,
					"y": 0.02500000037252903
				}, {
					"x": 0.42500001192092896,
					"y": 0
				}], [{
					"x": 0.6000000238418579,
					"y": 0
				}, {
					"x": 0.6000000238418579,
					"y": 0.02500000037252903
				}, {
					"x": 0.675000011920929,
					"y": 0.02500000037252903
				}, {
					"x": 0.675000011920929,
					"y": 0
				}]]);
	
				createSensors([{
					"x": 0.40000003576278687,
					"y": 0.4675002694129944
				}, {
					"x": 0.6333334445953369,
					"y": 0.10583360493183136
				}, {
					"x": 0.9766668081283569,
					"y": 0.5908335447311401
				}]);
	
				createDestination([{
					"x": 0.8500000238418579,
					"y": 0.4000000059604645
				}, {
					"x": 0.8500000238418579,
					"y": 0.42500001192092896
				}, {
					"x": 0.925000011920929,
					"y": 0.42500001192092896
				}, {
					"x": 0.925000011920929,
					"y": 0.4000000059604645
				}]);
			}
	
			function levelEight() {
	
				createStartPoint({
					"x": 0.5362499952316284,
					"y": 0.658750057220459
				}, 0.0850367397069931);
	
				createTerrain([{
					outer: [{
						"x": 0.17499999701976776,
						"y": 0.3499999940395355
					}, {
						"x": 0.30000001192092896,
						"y": 0.3499999940395355
					}, {
						"x": 0.32500001788139343,
						"y": 0.4749999940395355
					}, {
						"x": 0.3499999940395355,
						"y": 0.4749999940395355
					}, {
						"x": 0.375,
						"y": 0.3499999940395355
					}, {
						"x": 0.5,
						"y": 0.3499999940395355
					}, {
						"x": 0.623853325843811,
						"y": 0.35114577412605286
					}, {
						"x": 0.6363533735275269,
						"y": 0.6061457395553589
					}, {
						"x": -0.10000000149011612,
						"y": 0.574999988079071
					}, {
						"x": -0.10000000149011612,
						"y": 0.32500001788139343
					}],
					holes: [[{
						"x": 0.22500000894069672,
						"y": 0.45000001788139343
					}, {
						"x": 0.22500000894069672,
						"y": 0.4000000059604645
					}, {
						"x": 0.2750000059604645,
						"y": 0.4000000059604645
					}, {
						"x": 0.2750000059604645,
						"y": 0.45000001788139343
					}]]
				}, {
					outer: [{
						"x": 0.7250000238418579,
						"y": 0.6500000357627869
					}, {
						"x": 0.7250000238418579,
						"y": 0.3499999940395355
					}, {
						"x": 1,
						"y": 0.3499999940395355
					}, {
						"x": 1,
						"y": 0.675000011920929
					}],
					holes: []
				}]);
	
				createWalls([[{
					"x": 0.4331240653991699,
					"y": 0.3002082407474518
				}, {
					"x": 0.4749999940395355,
					"y": 0.32500001788139343
				}, {
					"x": 0.6438534259796143,
					"y": 0.3311457633972168
				}, {
					"x": 0.675000011920929,
					"y": 0.800000011920929
				}, {
					"x": 0.6734116673469543,
					"y": 0.6428385376930237
				}, {
					"x": 0.675000011920929,
					"y": 0.2750000059604645
				}, {
					"x": 0.824999988079071,
					"y": 0.2750000059604645
				}, {
					"x": 0.675000011920929,
					"y": 0.22500000894069672
				}, {
					"x": 0.38551995158195496,
					"y": 0.17572903633117676
				}], [{
					"x": 0,
					"y": 0.32500001788139343
				}, {
					"x": 0.20000000298023224,
					"y": 0.32500001788139343
				}, {
					"x": 0.2461974024772644,
					"y": 0.3000519573688507
				}, {
					"x": 0,
					"y": 0.30000001192092896
				}], [{
					"x": 0.4392699897289276,
					"y": 0.08364581316709518
				}, {
					"x": 0.415936678647995,
					"y": 0.00031246617436408997
				}, {
					"x": 0.6534367203712463,
					"y": -0.0005208663642406464
				}, {
					"x": 0.6209366917610168,
					"y": 0.08281248062849045
				}, {
					"x": 0.6034367084503174,
					"y": 0.011145807802677155
				}, {
					"x": 0.5709366798400879,
					"y": 0.08197914808988571
				}, {
					"x": 0.5434366464614868,
					"y": 0.014479130506515503
				}, {
					"x": 0.5067700147628784,
					"y": 0.0794791430234909
				}, {
					"x": 0.47010335326194763,
					"y": 0.013645797967910767
				}]]);
	
				createPushers([[{
					"x": 0.9000000357627869,
					"y": 0.02500000037252903
				}, {
					"x": 0.9000000357627869,
					"y": 0
				}, {
					"x": 0.9750000238418579,
					"y": 0
				}, {
					"x": 0.9750000238418579,
					"y": 0.02500000037252903
				}]]);
	
				var cross = createPolygon([{
					"x": 0.32500001788139343,
					"y": 0.4000000059604645
				}, {
					"x": 0.32500001788139343,
					"y": 0.32500001788139343
				}, {
					"x": 0.25,
					"y": 0.32500001788139343
				}, {
					"x": 0.25,
					"y": 0.30000001192092896
				}, {
					"x": 0.32500001788139343,
					"y": 0.30000001192092896
				}, {
					"x": 0.32500001788139343,
					"y": 0.22500000894069672
				}, {
					"x": 0.3499999940395355,
					"y": 0.22500000894069672
				}, {
					"x": 0.3499999940395355,
					"y": 0.30000001192092896
				}, {
					"x": 0.42500001192092896,
					"y": 0.30000001192092896
				}, {
					"x": 0.42500001192092896,
					"y": 0.32500001788139343
				}, {
					"x": 0.3499999940395355,
					"y": 0.32500001788139343
				}, {
					"x": 0.3499999940395355,
					"y": 0.4000000059604645
				}], {
					color: "#539124",
					type: "dynamic"
				});
	
				createRevoluteJoint(cross, {
					"x": 0.33791664242744446,
					"y": 0.31208330392837524
				}, 4);
	
				var platform = createPolygon([{
					"x": 0.17499999701976776,
					"y": 0.15000000596046448
				}, {
					"x": 0.17499999701976776,
					"y": 0.10000000149011612
				}, {
					"x": 0.42500001192092896,
					"y": 0.10000000149011612
				}, {
					"x": 0.30000001192092896,
					"y": 0.125
				}, {
					"x": 0.20000000298023224,
					"y": 0.125
				}, {
					"x": 0.20000000298023224,
					"y": 0.15000000596046448
				}], {
					color: "#583712",
					type: "dynamic",
					density: 0
				});
	
				var prismaticJoint = createPrismaticJoint(platform, {
					"x": 0.2820833921432495,
					"y": 0.13916654884815216
				}, new b2Vec2(1, 0), 4);
	
				platform.beginContact = function (obj) {
					if (obj.details.id === LEFT_WALL_ID) {
						prismaticJoint.SetMotorSpeed(-4);
					} else if (obj.details.id === RIGHT_WALL_ID) {
						prismaticJoint.SetMotorSpeed(4);
					}
				};
	
				createSensors([{
					"x": 0.05000000074505806,
					"y": 0.15000000596046448
				}, {
					"x": 0.25,
					"y": 0.42500001192092896
				}, {
					"x": 0.875,
					"y": 0.699999988079071
				}]);
	
				createDestination([{
					"x": 0.7250000238418579,
					"y": 0.30000001192092896
				}, {
					"x": 0.7250000238418579,
					"y": 0.2750000059604645
				}, {
					"x": 0.800000011920929,
					"y": 0.2750000059604645
				}, {
					"x": 0.800000011920929,
					"y": 0.30000001192092896
				}]);
			}
	
			function levelNine() {
	
				createStartPoint({
					"x": 0.9387500286102295,
					"y": 0.6687500476837158
				}, 0.08514697104692459);
	
				createTerrain([{
					outer: [{
						"x": 1.0391674041748047,
						"y": 0.6037503480911255
					}, {
						"x": 0.5024996399879456,
						"y": 0.6287503242492676
					}, {
						"x": 0.4008331894874573,
						"y": 0.398750364780426
					}, {
						"x": 0.20000000298023224,
						"y": 0.4000000059604645
					}, {
						"x": 0.22770798206329346,
						"y": 0.2039581835269928
					}, {
						"x": 0.3402080237865448,
						"y": 0.04270815849304199
					}, {
						"x": 0.22395800054073334,
						"y": 0.03145816922187805
					}, {
						"x": 0.20000000298023224,
						"y": 0
					}, {
						"x": 0.5658340454101562,
						"y": -0.0012495219707489014
					}],
					holes: []
				}, {
					outer: [{
						"x": 0.37010443210601807,
						"y": 0.5259372591972351
					}, {
						"x": 0.36635440587997437,
						"y": 0.504062294960022
					}, {
						"x": 0.396979421377182,
						"y": 0.5046873092651367
					}, {
						"x": 0.3907294273376465,
						"y": 0.5465623140335083
					}],
					holes: []
				}, {
					outer: [{
						"x": 0.26385441422462463,
						"y": 0.5578122735023499
					}, {
						"x": 0.2944794297218323,
						"y": 0.5315622687339783
					}, {
						"x": 0.29322943091392517,
						"y": 0.5071873068809509
					}, {
						"x": 0.26760441064834595,
						"y": 0.5065622925758362
					}],
					holes: []
				}]);
	
				createWalls([[{
					"x": 0.1541665941476822,
					"y": 0.04333317279815674
				}, {
					"x": 0.12874971330165863,
					"y": -0.0025001466274261475
				}, {
					"x": 0.17874972522258759,
					"y": -0.0025001466274261475
				}], [{
					"x": 0.6724997162818909,
					"y": 0.3587503135204315
				}, {
					"x": 0.6500000953674316,
					"y": 0
				}, {
					"x": 0.8750001192092896,
					"y": 0
				}, {
					"x": 0.819166362285614,
					"y": 0.3537503182888031
				}, {
					"x": 0.779167115688324,
					"y": 0.370417058467865
				}, {
					"x": 0.8250001668930054,
					"y": 0.05000000447034836
				}, {
					"x": 0.7000001668930054,
					"y": 0.05000000447034836
				}, {
					"x": 0.7108330726623535,
					"y": 0.3704169690608978
				}], [{
					"x": 0.2566669285297394,
					"y": 0.5041664242744446
				}, {
					"x": 0.2870830297470093,
					"y": 0.4891665577888489
				}, {
					"x": 0.37708303332328796,
					"y": 0.4891665577888489
				}, {
					"x": 0.40666693449020386,
					"y": 0.5041664242744446
				}], [{
					"x": 0.2752079963684082,
					"y": 0.02395816147327423
				}, {
					"x": 0.25,
					"y": 0
				}, {
					"x": 0.30000001192092896,
					"y": 0
				}]]);
	
				createPolygon([{
					"x": 0.2499999850988388,
					"y": 0.45000001788139343
				}, {
					"x": 0.22500000894069672,
					"y": 0.42500001192092896
				}, {
					"x": 0.2499999850988388,
					"y": 0.4000000059604645
				}, {
					"x": 0.2749999761581421,
					"y": 0.4000000059604645
				}, {
					"x": 0.30000001192092896,
					"y": 0.42500001192092896
				}, {
					"x": 0.2749999761581421,
					"y": 0.45000001788139343
				}], {
					color: "#342568",
					type: "dynamic",
					density: 8
				});
	
				var board = createPolygon([{
					"x": 0.027499929070472717,
					"y": 0.04999983310699463
				}, {
					"x": 0.02666659653186798,
					"y": 0.0958331748843193
				}, {
					"x": 0.03833329677581787,
					"y": 0.059999845921993256
				}, {
					"x": 0.06197904050350189,
					"y": 0.05989561975002289
				}, {
					"x": 0.10197903215885162,
					"y": 0.07052062451839447
				}, {
					"x": 0.25979161262512207,
					"y": 0.06520816683769226
				}, {
					"x": 0.3035416007041931,
					"y": 0.07270816713571548
				}, {
					"x": 0.2997916340827942,
					"y": 0.048958152532577515
				}], {
					color: "green",
					type: "dynamic",
					density: 0.5
				});
	
				createRevoluteJoint(board, {
					"x": 0.17625020444393158,
					"y": 0.06166665256023407
				});
	
				var hollow = createPolygon([{
					"x": 0.25822943449020386,
					"y": 0.5684372782707214
				}, {
					"x": 0.3316669464111328,
					"y": 0.5291664600372314
				}, {
					"x": 0.4313544034957886,
					"y": 0.582187294960022
				}, {
					"x": 0.3316669464111328,
					"y": 0.5041664242744446
				}], {
					color: "green",
					type: "dynamic",
					density: 0.5
				});
	
				createRevoluteJoint(hollow, {
					"x": 0.3318752348423004,
					"y": 0.5043748617172241
				});
	
				createPushers([[{
					"x": 0.925000011920929,
					"y": 0
				}, {
					"x": 0.925000011920929,
					"y": 0.02500000037252903
				}, {
					"x": 0.9750000238418579,
					"y": 0.02500000037252903
				}, {
					"x": 0.9750000238418579,
					"y": 0
				}]]);
	
				createSensors([{
					"x": 0.949999988079071,
					"y": 0.125
				}, {
					"x": 0.32500001788139343,
					"y": 0.574999988079071
				}, {
					"x": 0.07500000298023224,
					"y": 0.42500001192092896
				}]);
	
				createDestination([{
					"x": 0.7250000238418579,
					"y": 0.07500000298023224
				}, {
					"x": 0.7250000238418579,
					"y": 0.05000000074505806
				}, {
					"x": 0.800000011920929,
					"y": 0.05000000074505806
				}, {
					"x": 0.800000011920929,
					"y": 0.07500000298023224
				}]);
			}
	
			function createTerrain(data) {
				var polys = [];
				for (var i in data) {
					var obj = data[i];
					polys.push({
						outer: translatePoints(obj.outer),
						holes: translateHoles(obj.holes)
					});
				}
	
				__globals._terrain = new Body(_physics, {
					type: "static",
					shape: "terrain",
					patternImg: _resources.snowPattern,
					// color : "#996633",
					terrainPolys: polys
				});
			}
	
			function createBouncers(data, restitution) {
				for (var i in data) {
					var points = data[i];
					createPolygon(points, {
						color: "pink",
						restitution: 1.2
					});
				}
			}
	
			function createWalls(data) {
				for (var i in data) {
					var points = data[i];
					createPolygon(points, {
						color: "#C4460D",
						zIndex: 1
					});
				}
			}
	
			function createPushers(data) {
				for (var i in data) {
					var points = data[i];
					var pusher = createPolygon(points, {
						color: "red"
					});
	
					pusher.beginContact = function (obj) {
						if (obj.details.id === BALL_ID) {
							var body = obj.body;
							body.ApplyImpulse(new b2Vec2(0, -50), body.GetWorldCenter());
						}
					};
				}
			}
	
			function createStartPoint(point, r) {
	
				var pos = translatePoint(point);
	
				new Body(_physics, {
					id: START_POINT_ID,
					type: "static",
					color: "rgba(242,39,39,0.3)",
					shape: "circle",
					x: pos.x,
					y: pos.y,
					radius: r * _canvasW,
					isSensor: true
				});
			}
	
			function createPolygon(points, details) {
	
				var polyDetails = {
					type: "static",
					shape: "polygon",
					color: "e5e5e5",
					zIndex: 0,
					points: translatePoints(points)
				};
	
				for (var i in details) {
					polyDetails[i] = details[i];
				}
	
				return new Body(_physics, polyDetails);
			}
	
			function createSensors(points) {
				var sensorPoints = translatePoints(points);
	
				for (var i in sensorPoints) {
					var pos = sensorPoints[i];
					var sensor = new Body(_physics, {
						type: "static",
						image: _resources.bunnyImg,
						shape: "circle",
						zIndex: 1,
						x: pos.x,
						y: pos.y,
						radius: BUNNY_R,
						height: BUNNY_R * 2,
						width: BUNNY_R * 2,
						isSensor: true
					});
	
					sensor.beginContact = function (obj) {
						if (obj.details.id === BALL_ID) {
							this.details.dead = true;
						}
					};
				}
			}
	
			function createDestination(points) {
				var finishingPoint = new Body(_physics, {
					type: "static",
					shape: "polygon",
					color: "yellow",
					isSensor: true,
					zIndex: 1,
					points: translatePoints(points)
				});
	
				finishingPoint.beginContact = function (obj) {
					$('#level-dialog').dialog("open");
					finishingPoint.beginContact = undefined;
				};
			}
	
			function createRevoluteJoint(obj, point, motorSpeed) {
				var revoluteJointDef = new b2RevoluteJointDef();
	
				var anchor = translatePoint({
					"x": point.x,
					"y": point.y
				});
	
				revoluteJointDef.Initialize(_physics.world.GetGroundBody(), obj.body, new b2Vec2(anchor.x / _physics.scale, anchor.y / _physics.scale));
	
				revoluteJointDef.maxMotorTorque = 5.0;
				revoluteJointDef.motorSpeed = motorSpeed || 0;
				revoluteJointDef.enableMotor = true;
	
				return _physics.world.CreateJoint(revoluteJointDef);
			}
	
			function createPrismaticJoint(obj, point, axis, speed) {
				var prismaticJointDef = new b2PrismaticJointDef();
	
				var anchor = translatePoint({
					"x": point.x,
					"y": point.y
				});
	
				prismaticJointDef.Initialize(obj.body, _physics.world.GetGroundBody(), new b2Vec2(anchor.x / _physics.scale, anchor.y / _physics.scale), axis);
	
				prismaticJointDef.maxMotorForce = 10.0;
				prismaticJointDef.motorSpeed = speed || 0;
				prismaticJointDef.enableMotor = true;
	
				return _physics.world.CreateJoint(prismaticJointDef);
			}
	
			function translateHoles(shapes) {
				var translated = [];
				for (var i in shapes) {
	
					// Holes are CCW
					translated.push(translatePoints(shapes[i]).reverse());
				}
				return translated;
			}
	
			function translatePoints(points) {
				var translated = [];
				for (var i in points) {
					translated.push(translatePoint(points[i]));
				}
				return translated;
			}
	
			function translatePoint(point) {
				return {
					x: point.x * _canvasW,
					y: _canvasH - point.y * _canvasW
				};
			}
	
			this.load = function (pos) {
				return levels[pos]();
			};
	
			this.levels = levels;
		}
	
		module.exports = levelLoader;
	})();
	
	// var _levelLoader = {
	// 	levels : [levelOne, levelTwo, levelThree, levelFour, levelFive, levelSix,
	// 			levelSeven, levelEight, levelNine],
	// 	load : function(pos) {
	// 		this.levels[pos]();
	// 	}
	// };
	//
	// function levelOne() {
	//
	// 	createStartPoint({
	// 		"x" : 0.5537500381469727,
	// 		"y" : 0.6912499666213989
	// 	}, 0.09500002861022949);
	//
	// 	createTerrain([{
	// 		outer : [{
	// 			"x" : 0.001249939203262329,
	// 			"y" : 0.7137500047683716
	// 		}, {
	// 			"x" : 0.32624995708465576,
	// 			"y" : 0.6137499809265137
	// 		}, {
	// 			"x" : 0.47624993324279785,
	// 			"y" : 0.5887500047683716
	// 		}, {
	// 			"x" : 0.5762499570846558,
	// 			"y" : 0.5387499928474426
	// 		}, {
	// 			"x" : 0.6512500047683716,
	// 			"y" : 0.5887500047683716
	// 		}, {
	// 			"x" : 1.00124990940094,
	// 			"y" : 0.6887499690055847
	// 		}, {
	// 			"x" : 1.00124990940094,
	// 			"y" : 0.18874996900558472
	// 		}, {
	// 			"x" : 0.001249939203262329,
	// 			"y" : 0.18874996900558472
	// 		}],
	// 		holes : [[{
	// 			"x" : 0.37624993920326233,
	// 			"y" : 0.5137499570846558
	// 		}, {
	// 			"x" : 0.37624993920326233,
	// 			"y" : 0.4637500047683716
	// 		}, {
	// 			"x" : 0.4262499511241913,
	// 			"y" : 0.4637500047683716
	// 		}, {
	// 			"x" : 0.4262499511241913,
	// 			"y" : 0.5137499570846558
	// 		}], [{
	// 			"x" : 0.6012499332427979,
	// 			"y" : 0.38874995708465576
	// 		}, {
	// 			"x" : 0.6012499332427979,
	// 			"y" : 0.4387499690055847
	// 		}, {
	// 			"x" : 0.6512500047683716,
	// 			"y" : 0.4387499690055847
	// 		}, {
	// 			"x" : 0.6512500047683716,
	// 			"y" : 0.38874995708465576
	// 		}], [{
	// 			"x" : 0.47624993324279785,
	// 			"y" : 0.3137499690055847
	// 		}, {
	// 			"x" : 0.47624993324279785,
	// 			"y" : 0.26374995708465576
	// 		}, {
	// 			"x" : 0.5262500047683716,
	// 			"y" : 0.26374995708465576
	// 		}, {
	// 			"x" : 0.5262500047683716,
	// 			"y" : 0.3137499690055847
	// 		}]]
	// 	}]);
	//
	// 	createSensors([{
	// 		"x" : 0.4012499451637268,
	// 		"y" : 0.48874998092651367
	// 	}, {
	// 		"x" : 0.6262499094009399,
	// 		"y" : 0.4137499928474426
	// 	}, {
	// 		"x" : 0.5012499094009399,
	// 		"y" : 0.28874996304512024
	// 	}]);
	//
	// 	createDestination([{
	// 		"x" : 0.42500001192092896,
	// 		"y" : 0
	// 	}, {
	// 		"x" : 0.42500001192092896,
	// 		"y" : 0.02500000037252903
	// 	}, {
	// 		"x" : 0.550000011920929,
	// 		"y" : 0.02500000037252903
	// 	}, {
	// 		"x" : 0.550000011920929,
	// 		"y" : 0
	// 	}]);
	//
	// }
	//
	// function levelTwo() {
	//
	// 	createStartPoint({
	// 		"x" : 0.11624997854232788,
	// 		"y" : 0.6937499642372131
	// 	}, 0.08933781832456589);
	//
	// 	createTerrain([{
	// 		outer : [{
	// 			"x" : 0,
	// 			"y" : 0.550000011920929
	// 		}, {
	// 			"x" : 0.32500001788139343,
	// 			"y" : 0.6500000357627869
	// 		}, {
	// 			"x" : 0.6000000238418579,
	// 			"y" : 0.625
	// 		}, {
	// 			"x" : 0.875,
	// 			"y" : 0.625
	// 		}, {
	// 			"x" : 0.9750000238418579,
	// 			"y" : 0.4749999940395355
	// 		}, {
	// 			"x" : 0.8500000238418579,
	// 			"y" : 0.25
	// 		}, {
	// 			"x" : 0.625,
	// 			"y" : 0.17499999701976776
	// 		}, {
	// 			"x" : 0.2750000059604645,
	// 			"y" : 0.20000000298023224
	// 		}, {
	// 			"x" : 0,
	// 			"y" : 0.2750000059604645
	// 		}],
	// 		holes : [[{
	// 			"x" : 0.45000001788139343,
	// 			"y" : 0.2750000059604645
	// 		}, {
	// 			"x" : 0.45000001788139343,
	// 			"y" : 0.22500000894069672
	// 		}, {
	// 			"x" : 0.5,
	// 			"y" : 0.22500000894069672
	// 		}, {
	// 			"x" : 0.5,
	// 			"y" : 0.2750000059604645
	// 		}], [{
	// 			"x" : 0.25,
	// 			"y" : 0.574999988079071
	// 		}, {
	// 			"x" : 0.25,
	// 			"y" : 0.5250000357627869
	// 		}, {
	// 			"x" : 0.30000001192092896,
	// 			"y" : 0.5250000357627869
	// 		}, {
	// 			"x" : 0.30000001192092896,
	// 			"y" : 0.574999988079071
	// 		}], [{
	// 			"x" : 0.824999988079071,
	// 			"y" : 0.5250000357627869
	// 		}, {
	// 			"x" : 0.824999988079071,
	// 			"y" : 0.4749999940395355
	// 		}, {
	// 			"x" : 0.875,
	// 			"y" : 0.4749999940395355
	// 		}, {
	// 			"x" : 0.875,
	// 			"y" : 0.5250000357627869
	// 		}]]
	// 	}]);
	//
	// 	// create a wall
	//
	// 	createWalls([[{
	// 		"x" : 0.22500000894069672,
	// 		"y" : 0.45000001788139343
	// 	}, {
	// 		"x" : 0.675000011920929,
	// 		"y" : 0.45000001788139343
	// 	}, {
	// 		"x" : 0.7875000238418579,
	// 		"y" : 0.4000000059604645
	// 	}, {
	// 		"x" : 0.4749999940395355,
	// 		"y" : 0.42500001192092896
	// 	}, {
	// 		"x" : 0.16249997913837433,
	// 		"y" : 0.4000000059604645
	// 	}]]);
	//
	// 	createSensors([{
	// 		"x" : 0.2750000059604645,
	// 		"y" : 0.550000011920929
	// 	}, {
	// 		"x" : 0.8500000238418579,
	// 		"y" : 0.5
	// 	}, {
	// 		"x" : 0.4749999940395355,
	// 		"y" : 0.25
	// 	}]);
	//
	// 	createDestination([{
	// 		"x" : 0.4000000059604645,
	// 		"y" : 0.02500000037252903
	// 	}, {
	// 		"x" : 0.4000000059604645,
	// 		"y" : 0
	// 	}, {
	// 		"x" : 0.550000011920929,
	// 		"y" : 0
	// 	}, {
	// 		"x" : 0.550000011920929,
	// 		"y" : 0.02500000037252903
	// 	}]);
	//
	// }
	//
	// function levelThree() {
	//
	// 	createStartPoint({
	// 		"x" : 0.8612500429153442,
	// 		"y" : 0.7162500023841858
	// 	}, 0.06543124467134476);
	//
	// 	createTerrain([{
	// 		outer : [{
	// 			"x" : 0.925000011920929,
	// 			"y" : 0.675000011920929
	// 		}, {
	// 			"x" : -0.05000000074505806,
	// 			"y" : 0.625
	// 		}, {
	// 			"x" : 0.05000000074505806,
	// 			"y" : 0.42500001192092896
	// 		}, {
	// 			"x" : 0.925000011920929,
	// 			"y" : 0.4749999940395355
	// 		}],
	// 		holes : [[{
	// 			"x" : 0.05000000074505806,
	// 			"y" : 0.574999988079071
	// 		}, {
	// 			"x" : 0.05000000074505806,
	// 			"y" : 0.5250000357627869
	// 		}, {
	// 			"x" : 0.10000000149011612,
	// 			"y" : 0.5250000357627869
	// 		}, {
	// 			"x" : 0.10000000149011612,
	// 			"y" : 0.574999988079071
	// 		}]]
	// 	}, {
	// 		outer : [{
	// 			"x" : 0.05000000074505806,
	// 			"y" : 0.2750000059604645
	// 		}, {
	// 			"x" : 0.05000000074505806,
	// 			"y" : 0.10000000149011612
	// 		}, {
	// 			"x" : 0.4000000059604645,
	// 			"y" : 0.07500000298023224
	// 		}, {
	// 			"x" : 0.3499999940395355,
	// 			"y" : 0.3499999940395355
	// 		}],
	// 		holes : []
	// 	}]);
	//
	// 	createWalls([[{
	// 		"x" : 0.45000001788139343,
	// 		"y" : 0.22500000894069672
	// 	}, {
	// 		"x" : 0.699999988079071,
	// 		"y" : 0.15000000596046448
	// 	}, {
	// 		"x" : 0.699999988079071,
	// 		"y" : 0
	// 	}, {
	// 		"x" : 0.75,
	// 		"y" : 0
	// 	}, {
	// 		"x" : 0.75,
	// 		"y" : 0.20000000298023224
	// 	}], [{
	// 		"x" : 0.949999988079071,
	// 		"y" : 0.42500001192092896
	// 	}, {
	// 		"x" : 0.22500000894069672,
	// 		"y" : 0.4000000059604645
	// 	}, {
	// 		"x" : 0.949999988079071,
	// 		"y" : 0.3499999940395355
	// 	}]]);
	//
	// 	createSensors([{
	// 		"x" : 0.07500000298023224,
	// 		"y" : 0.550000011920929
	// 	}, {
	// 		"x" : 0.125,
	// 		"y" : 0.375
	// 	}, {
	// 		"x" : 0.5,
	// 		"y" : 0.30000001192092896
	// 	}]);
	//
	// 	createDestination([{
	// 		"x" : 0.800000011920929,
	// 		"y" : 0.02500000037252903
	// 	}, {
	// 		"x" : 0.800000011920929,
	// 		"y" : 0
	// 	}, {
	// 		"x" : 0.9000000357627869,
	// 		"y" : 0
	// 	}, {
	// 		"x" : 0.9000000357627869,
	// 		"y" : 0.02500000037252903
	// 	}]);
	// }
	//
	// function levelFour() {
	//
	// 	createStartPoint({
	// 		"x" : 0.14874997735023499,
	// 		"y" : 0.7212499976158142
	// 	}, 0.08746424317359924);
	//
	// 	createTerrain([{
	// 		outer : [{
	// 			"x" : -0.0012500286102294922,
	// 			"y" : 0.7162500023841858
	// 		}, {
	// 			"x" : 0.14874997735023499,
	// 			"y" : 0.6687500476837158
	// 		}, {
	// 			"x" : 0.32124996185302734,
	// 			"y" : 0.7112500071525574
	// 		}, {
	// 			"x" : 0.3187500238418579,
	// 			"y" : 0.4287499785423279
	// 		}, {
	// 			"x" : 0.47874999046325684,
	// 			"y" : 0.20624998211860657
	// 		}, {
	// 			"x" : 0.001249939203262329,
	// 			"y" : 0.2137499749660492
	// 		}],
	// 		holes : [[{
	// 			"x" : 0.2750000059604645,
	// 			"y" : 0.30000001192092896
	// 		}, {
	// 			"x" : 0.2750000059604645,
	// 			"y" : 0.25
	// 		}, {
	// 			"x" : 0.32500001788139343,
	// 			"y" : 0.25
	// 		}, {
	// 			"x" : 0.32500001788139343,
	// 			"y" : 0.30000001192092896
	// 		}]]
	// 	}, {
	// 		outer : [{
	// 			"x" : 0.7250000238418579,
	// 			"y" : 0.699999988079071
	// 		}, {
	// 			"x" : 0.6500000357627869,
	// 			"y" : 0.17499999701976776
	// 		}, {
	// 			"x" : 0.949999988079071,
	// 			"y" : 0.17499999701976776
	// 		}, {
	// 			"x" : 0.949999988079071,
	// 			"y" : 0.675000011920929
	// 		}],
	// 		holes : []
	// 	}]);
	//
	// 	createWalls([[{
	// 		"x" : 0.574999988079071,
	// 		"y" : 0.32500001788139343
	// 	}, {
	// 		"x" : 0.550000011920929,
	// 		"y" : 0
	// 	}, {
	// 		"x" : 0.625,
	// 		"y" : 0
	// 	}]]);
	//
	// 	createSensors([{
	// 		"x" : 0.30000001192092896,
	// 		"y" : 0.2750000059604645
	// 	}, {
	// 		"x" : 0.574999988079071,
	// 		"y" : 0.42500001192092896
	// 	}, {
	// 		"x" : 0.7250000238418579,
	// 		"y" : 0.05000000074505806
	// 	}]);
	//
	// 	createDestination([{
	// 		"x" : 0.800000011920929,
	// 		"y" : 0.02500000037252903
	// 	}, {
	// 		"x" : 0.800000011920929,
	// 		"y" : 0
	// 	}, {
	// 		"x" : 0.9000000357627869,
	// 		"y" : 0
	// 	}, {
	// 		"x" : 0.9000000357627869,
	// 		"y" : 0.02500000037252903
	// 	}]);
	// }
	//
	// function levelFive() {
	//
	// 	createStartPoint({
	//         "x": 0.09874996542930603,
	//         "y": 0.5537500381469727
	//     }, 0.12454922497272491);
	//
	// 	createTerrain([{
	// 		outer : [{
	// 			"x" : -0.1012500524520874,
	// 			"y" : 0.4912499785423279
	// 		}, {
	// 			"x" : 0.2887499928474426,
	// 			"y" : 0.5112499594688416
	// 		}, {
	// 			"x" : 0.3037499785423279,
	// 			"y" : 0.1887499988079071
	// 		}, {
	// 			"x" : -0.07625001668930054,
	// 			"y" : 0.19374996423721313
	// 		}],
	// 		holes : []
	// 	}]);
	//
	// 	createBouncers([[{
	// 		"x" : 0.25,
	// 		"y" : 0
	// 	}, {
	// 		"x" : 0.25,
	// 		"y" : 0.02500000037252903
	// 	}, {
	// 		"x" : 0.32500001788139343,
	// 		"y" : 0.02500000037252903
	// 	}, {
	// 		"x" : 0.32500001788139343,
	// 		"y" : 0
	// 	}], [{
	// 		"x" : 0.375,
	// 		"y" : 0.6000000238418579
	// 	}, {
	// 		"x" : 0.375,
	// 		"y" : 0.550000011920929
	// 	}, {
	// 		"x" : 0.550000011920929,
	// 		"y" : 0.6000000238418579
	// 	}, {
	// 		"x" : 0.550000011920929,
	// 		"y" : 0.6500000357627869
	// 	}], [{
	// 		"x" : 0.574999988079071,
	// 		"y" : 0
	// 	}, {
	// 		"x" : 0.5750000476837158,
	// 		"y" : 0.02500000037252903
	// 	}, {
	// 		"x" : 0.6500000357627869,
	// 		"y" : 0.02500000037252903
	// 	}, {
	// 		"x" : 0.6500000357627869,
	// 		"y" : 0
	// 	}], [{
	// 		"x" : 0.800000011920929,
	// 		"y" : 0.375
	// 	}, {
	// 		"x" : 0.800000011920929,
	// 		"y" : 0.32500001788139343
	// 	}, {
	// 		"x" : 1.0162501335144043,
	// 		"y" : 0.32625001668930054
	// 	}, {
	// 		"x" : 1.0162501335144043,
	// 		"y" : 0.3762499988079071
	// 	}]], 1.2);
	//
	// 	createSensors([{
	// 		"x" : 0.3499999940395355,
	// 		"y" : 0.32500001788139343
	// 	}, {
	// 		"x" : 0.75,
	// 		"y" : 0.4749999940395355
	// 	}, {
	// 		"x" : 0.625,
	// 		"y" : 0.2750000059604645
	// 	}]);
	//
	// 	createDestination([{
	// 		"x" : 0.8500000238418579,
	// 		"y" : 0.4000000059604645
	// 	}, {
	// 		"x" : 0.8500000238418579,
	// 		"y" : 0.375
	// 	}, {
	// 		"x" : 0.925000011920929,
	// 		"y" : 0.375
	// 	}, {
	// 		"x" : 0.925000011920929,
	// 		"y" : 0.4000000059604645
	// 	}]);
	//
	// }
	//
	// function levelSix() {
	//
	// 	createStartPoint({
	//         "x": 0.13874998688697815,
	//         "y": 0.6962499618530273
	//     }, 0.09890014678239822);
	//
	// 	createTerrain([{
	// 		outer : [{
	// 			"x" : -0.06791657209396362,
	// 			"y" : 0.6770836114883423
	// 		}, {
	// 			"x" : 0.5291669368743896,
	// 			"y" : 0.5366671681404114
	// 		}, {
	// 			"x" : 1.032083511352539,
	// 			"y" : 0.6070836186408997
	// 		}, {
	// 			"x" : 1.024999976158142,
	// 			"y" : -0.024999964982271194
	// 		}, {
	// 			"x" : -0.05000000074505806,
	// 			"y" : -0.05000000074505806
	// 		}],
	// 		holes : [[{
	// 			"x" : 0.4845834970474243,
	// 			"y" : 0.1420835703611374
	// 		}, {
	// 			"x" : 0.5595834851264954,
	// 			"y" : 0.2420835793018341
	// 		}, {
	// 			"x" : 0.6595834493637085,
	// 			"y" : 0.2670835852622986
	// 		}, {
	// 			"x" : 0.7095835208892822,
	// 			"y" : 0.16708357632160187
	// 		}, {
	// 			"x" : 0.6345835328102112,
	// 			"y" : 0.09208357334136963
	// 		}, {
	// 			"x" : 0.5595834851264954,
	// 			"y" : 0.09208357334136963
	// 		}], [{
	// 			"x" : 0.8345835208892822,
	// 			"y" : 0.16708357632160187
	// 		}, {
	// 			"x" : 0.8345835208892822,
	// 			"y" : 0.1170835793018341
	// 		}, {
	// 			"x" : 0.8845834732055664,
	// 			"y" : 0.1170835793018341
	// 		}, {
	// 			"x" : 0.8845834732055664,
	// 			"y" : 0.16708357632160187
	// 		}], [{
	// 			"x" : 0.7595834732055664,
	// 			"y" : 0.2420835793018341
	// 		}, {
	// 			"x" : 0.7595834732055664,
	// 			"y" : 0.19208358228206635
	// 		}, {
	// 			"x" : 0.8095834851264954,
	// 			"y" : 0.19208358228206635
	// 		}, {
	// 			"x" : 0.8095834851264954,
	// 			"y" : 0.2420835793018341
	// 		}]]
	// 	}]);
	//
	// 	createBouncers([[{
	// 		"x" : 0.9645834565162659,
	// 		"y" : 0.6920835971832275
	// 	}, {
	// 		"x" : 0.9820835590362549,
	// 		"y" : 0.6095836162567139
	// 	}, {
	// 		"x" : 1.032083511352539,
	// 		"y" : 0.6120836138725281
	// 	}, {
	// 		"x" : 1.0195834636688232,
	// 		"y" : 0.6920835971832275
	// 	}]]);
	//
	// 	createWalls([[{
	// 		"x" : 0.43458348512649536,
	// 		"y" : 0.1420835703611374
	// 	}, {
	// 		"x" : 0.45958349108695984,
	// 		"y" : 0.1170835793018341
	// 	}, {
	// 		"x" : 0.7595834732055664,
	// 		"y" : 0.1170835793018341
	// 	}, {
	// 		"x" : 0.7595834732055664,
	// 		"y" : 0.1420835703611374
	// 	}]]);
	//
	// 	createSensors([{
	// 		"x" : 0.8695834875106812,
	// 		"y" : 0.6120836138725281
	// 	}, {
	// 		"x" : 0.7845835089683533,
	// 		"y" : 0.21708357334136963
	// 	}, {
	// 		"x" : 0.8595834970474243,
	// 		"y" : 0.1420835703611374
	// 	}]);
	//
	// 	createDestination([{
	// 		"x" : 0.5595834851264954,
	// 		"y" : 0.16708357632160187
	// 	}, {
	// 		"x" : 0.5595834851264954,
	// 		"y" : 0.1420835703611374
	// 	}, {
	// 		"x" : 0.6345835328102112,
	// 		"y" : 0.1420835703611374
	// 	}, {
	// 		"x" : 0.6345835328102112,
	// 		"y" : 0.16708357632160187
	// 	}]);
	//
	// }
	//
	// function levelSeven() {
	//
	// 	createStartPoint({
	// 		"x" : 0.8337500691413879,
	// 		"y" : 0.7287499904632568
	// 	}, 0.08321647346019745);
	//
	// 	createTerrain([{
	// 		outer : [{
	// 			"x" : -0.02500000037252903,
	// 			"y" : 0.574999988079071
	// 		}, {
	// 			"x" : 0.17499999701976776,
	// 			"y" : 0.42500001192092896
	// 		}, {
	// 			"x" : 0.45000001788139343,
	// 			"y" : 0.4000000059604645
	// 		}, {
	// 			"x" : 0.4749999940395355,
	// 			"y" : 0.125
	// 		}, {
	// 			"x" : -0.07500000298023224,
	// 			"y" : -0.02500000037252903
	// 		}],
	// 		holes : []
	// 	}, {
	// 		outer : [{
	// 			"x" : 0.3499999940395355,
	// 			"y" : 0.675000011920929
	// 		}, {
	// 			"x" : 0.25,
	// 			"y" : 0.574999988079071
	// 		}, {
	// 			"x" : 0.9000000357627869,
	// 			"y" : 0.5
	// 		}, {
	// 			"x" : 0.925000011920929,
	// 			"y" : 0.675000011920929
	// 		}],
	// 		holes : []
	// 	}]);
	//
	// 	createWalls([[{
	// 		"x" : 0.42500001192092896,
	// 		"y" : 0
	// 	}, {
	// 		"x" : 0.5070834159851074,
	// 		"y" : 0.28708362579345703
	// 	}, {
	// 		"x" : 0.550000011920929,
	// 		"y" : 0
	// 	}], [{
	// 		"x" : 0.699999988079071,
	// 		"y" : 0
	// 	}, {
	// 		"x" : 0.675000011920929,
	// 		"y" : 0.2750000059604645
	// 	}, {
	// 		"x" : 0.7750000357627869,
	// 		"y" : 0
	// 	}], [{
	// 		"x" : 0.18083345890045166,
	// 		"y" : 0.3008336126804352
	// 	}, {
	// 		"x" : 0.19333338737487793,
	// 		"y" : 0.2708336114883423
	// 	}, {
	// 		"x" : 0.33083340525627136,
	// 		"y" : 0.2708336114883423
	// 	}, {
	// 		"x" : 0.32333338260650635,
	// 		"y" : 0.3008336126804352
	// 	}], [{
	// 		"x" : 0.8500000238418579,
	// 		"y" : 0.4000000059604645
	// 	}, {
	// 		"x" : 0.8500000238418579,
	// 		"y" : 0.3499999940395355
	// 	}, {
	// 		"x" : 0.9950001239776611,
	// 		"y" : 0.3541669249534607
	// 	}, {
	// 		"x" : 1.0066670179367065,
	// 		"y" : 0.5266672372817993
	// 	}, {
	// 		"x" : 0.949999988079071,
	// 		"y" : 0.4000000059604645
	// 	}]]);
	//
	// 	var board = createPolygon([{
	// 		"x" : 0.47500014305114746,
	// 		"y" : 0.46250027418136597
	// 	}, {
	// 		"x" : 0.49125006794929504,
	// 		"y" : 0.2987503111362457
	// 	}, {
	// 		"x" : 0.5237500667572021,
	// 		"y" : 0.30125030875205994
	// 	}, {
	// 		"x" : 0.5066667795181274,
	// 		"y" : 0.4725002646446228
	// 	}], {
	// 		color : "green",
	// 		type : "dynamic",
	// 		density : 0.5
	// 	});
	//
	// 	createRevoluteJoint(board, {
	// 		"x" : 0.5045833587646484,
	// 		"y" : 0.3120836615562439
	// 	}, 4);
	//
	// 	createPushers([[{
	// 		"x" : 0.3499999940395355,
	// 		"y" : 0
	// 	}, {
	// 		"x" : 0.3499999940395355,
	// 		"y" : 0.02500000037252903
	// 	}, {
	// 		"x" : 0.42500001192092896,
	// 		"y" : 0.02500000037252903
	// 	}, {
	// 		"x" : 0.42500001192092896,
	// 		"y" : 0
	// 	}], [{
	// 		"x" : 0.6000000238418579,
	// 		"y" : 0
	// 	}, {
	// 		"x" : 0.6000000238418579,
	// 		"y" : 0.02500000037252903
	// 	}, {
	// 		"x" : 0.675000011920929,
	// 		"y" : 0.02500000037252903
	// 	}, {
	// 		"x" : 0.675000011920929,
	// 		"y" : 0
	// 	}]]);
	//
	// 	createSensors([{
	// 		"x" : 0.40000003576278687,
	// 		"y" : 0.4675002694129944
	// 	}, {
	// 		"x" : 0.6333334445953369,
	// 		"y" : 0.10583360493183136
	// 	}, {
	// 		"x" : 0.9766668081283569,
	// 		"y" : 0.5908335447311401
	// 	}]);
	//
	// 	createDestination([{
	// 		"x" : 0.8500000238418579,
	// 		"y" : 0.4000000059604645
	// 	}, {
	// 		"x" : 0.8500000238418579,
	// 		"y" : 0.42500001192092896
	// 	}, {
	// 		"x" : 0.925000011920929,
	// 		"y" : 0.42500001192092896
	// 	}, {
	// 		"x" : 0.925000011920929,
	// 		"y" : 0.4000000059604645
	// 	}]);
	//
	// }
	//
	// function levelEight() {
	//
	// 	createStartPoint({
	// 		"x" : 0.5362499952316284,
	// 		"y" : 0.658750057220459
	// 	}, 0.0850367397069931);
	//
	// 	createTerrain([{
	// 		outer : [{
	// 			"x" : 0.17499999701976776,
	// 			"y" : 0.3499999940395355
	// 		}, {
	// 			"x" : 0.30000001192092896,
	// 			"y" : 0.3499999940395355
	// 		}, {
	// 			"x" : 0.32500001788139343,
	// 			"y" : 0.4749999940395355
	// 		}, {
	// 			"x" : 0.3499999940395355,
	// 			"y" : 0.4749999940395355
	// 		}, {
	// 			"x" : 0.375,
	// 			"y" : 0.3499999940395355
	// 		}, {
	// 			"x" : 0.5,
	// 			"y" : 0.3499999940395355
	// 		}, {
	// 			"x" : 0.623853325843811,
	// 			"y" : 0.35114577412605286
	// 		}, {
	// 			"x" : 0.6363533735275269,
	// 			"y" : 0.6061457395553589
	// 		}, {
	// 			"x" : -0.10000000149011612,
	// 			"y" : 0.574999988079071
	// 		}, {
	// 			"x" : -0.10000000149011612,
	// 			"y" : 0.32500001788139343
	// 		}],
	// 		holes : [[{
	// 			"x" : 0.22500000894069672,
	// 			"y" : 0.45000001788139343
	// 		}, {
	// 			"x" : 0.22500000894069672,
	// 			"y" : 0.4000000059604645
	// 		}, {
	// 			"x" : 0.2750000059604645,
	// 			"y" : 0.4000000059604645
	// 		}, {
	// 			"x" : 0.2750000059604645,
	// 			"y" : 0.45000001788139343
	// 		}]]
	// 	}, {
	// 		outer : [{
	// 			"x" : 0.7250000238418579,
	// 			"y" : 0.6500000357627869
	// 		}, {
	// 			"x" : 0.7250000238418579,
	// 			"y" : 0.3499999940395355
	// 		}, {
	// 			"x" : 1,
	// 			"y" : 0.3499999940395355
	// 		}, {
	// 			"x" : 1,
	// 			"y" : 0.675000011920929
	// 		}],
	// 		holes : []
	// 	}]);
	//
	// 	createWalls([[{
	// 		"x" : 0.4331240653991699,
	// 		"y" : 0.3002082407474518
	// 	}, {
	// 		"x" : 0.4749999940395355,
	// 		"y" : 0.32500001788139343
	// 	}, {
	// 		"x" : 0.6438534259796143,
	// 		"y" : 0.3311457633972168
	// 	}, {
	// 		"x" : 0.675000011920929,
	// 		"y" : 0.800000011920929
	// 	}, {
	// 		"x" : 0.6734116673469543,
	// 		"y" : 0.6428385376930237
	// 	}, {
	// 		"x" : 0.675000011920929,
	// 		"y" : 0.2750000059604645
	// 	}, {
	// 		"x" : 0.824999988079071,
	// 		"y" : 0.2750000059604645
	// 	}, {
	// 		"x" : 0.675000011920929,
	// 		"y" : 0.22500000894069672
	// 	}, {
	// 		"x" : 0.38551995158195496,
	// 		"y" : 0.17572903633117676
	// 	}], [{
	// 		"x" : 0,
	// 		"y" : 0.32500001788139343
	// 	}, {
	// 		"x" : 0.20000000298023224,
	// 		"y" : 0.32500001788139343
	// 	}, {
	// 		"x" : 0.2461974024772644,
	// 		"y" : 0.3000519573688507
	// 	}, {
	// 		"x" : 0,
	// 		"y" : 0.30000001192092896
	// 	}], [{
	// 		"x" : 0.4392699897289276,
	// 		"y" : 0.08364581316709518
	// 	}, {
	// 		"x" : 0.415936678647995,
	// 		"y" : 0.00031246617436408997
	// 	}, {
	// 		"x" : 0.6534367203712463,
	// 		"y" : -0.0005208663642406464
	// 	}, {
	// 		"x" : 0.6209366917610168,
	// 		"y" : 0.08281248062849045
	// 	}, {
	// 		"x" : 0.6034367084503174,
	// 		"y" : 0.011145807802677155
	// 	}, {
	// 		"x" : 0.5709366798400879,
	// 		"y" : 0.08197914808988571
	// 	}, {
	// 		"x" : 0.5434366464614868,
	// 		"y" : 0.014479130506515503
	// 	}, {
	// 		"x" : 0.5067700147628784,
	// 		"y" : 0.0794791430234909
	// 	}, {
	// 		"x" : 0.47010335326194763,
	// 		"y" : 0.013645797967910767
	// 	}]]);
	//
	// 	createPushers([[{
	// 		"x" : 0.9000000357627869,
	// 		"y" : 0.02500000037252903
	// 	}, {
	// 		"x" : 0.9000000357627869,
	// 		"y" : 0
	// 	}, {
	// 		"x" : 0.9750000238418579,
	// 		"y" : 0
	// 	}, {
	// 		"x" : 0.9750000238418579,
	// 		"y" : 0.02500000037252903
	// 	}]]);
	//
	// 	var cross = createPolygon([{
	// 		"x" : 0.32500001788139343,
	// 		"y" : 0.4000000059604645
	// 	}, {
	// 		"x" : 0.32500001788139343,
	// 		"y" : 0.32500001788139343
	// 	}, {
	// 		"x" : 0.25,
	// 		"y" : 0.32500001788139343
	// 	}, {
	// 		"x" : 0.25,
	// 		"y" : 0.30000001192092896
	// 	}, {
	// 		"x" : 0.32500001788139343,
	// 		"y" : 0.30000001192092896
	// 	}, {
	// 		"x" : 0.32500001788139343,
	// 		"y" : 0.22500000894069672
	// 	}, {
	// 		"x" : 0.3499999940395355,
	// 		"y" : 0.22500000894069672
	// 	}, {
	// 		"x" : 0.3499999940395355,
	// 		"y" : 0.30000001192092896
	// 	}, {
	// 		"x" : 0.42500001192092896,
	// 		"y" : 0.30000001192092896
	// 	}, {
	// 		"x" : 0.42500001192092896,
	// 		"y" : 0.32500001788139343
	// 	}, {
	// 		"x" : 0.3499999940395355,
	// 		"y" : 0.32500001788139343
	// 	}, {
	// 		"x" : 0.3499999940395355,
	// 		"y" : 0.4000000059604645
	// 	}], {
	// 		color : "#539124",
	// 		type : "dynamic"
	// 	});
	//
	// 	createRevoluteJoint(cross, {
	// 		"x" : 0.33791664242744446,
	// 		"y" : 0.31208330392837524
	// 	}, 4);
	//
	// 	var platform = createPolygon([{
	// 		"x" : 0.17499999701976776,
	// 		"y" : 0.15000000596046448
	// 	}, {
	// 		"x" : 0.17499999701976776,
	// 		"y" : 0.10000000149011612
	// 	}, {
	// 		"x" : 0.42500001192092896,
	// 		"y" : 0.10000000149011612
	// 	}, {
	// 		"x" : 0.30000001192092896,
	// 		"y" : 0.125
	// 	}, {
	// 		"x" : 0.20000000298023224,
	// 		"y" : 0.125
	// 	}, {
	// 		"x" : 0.20000000298023224,
	// 		"y" : 0.15000000596046448
	// 	}], {
	// 		color : "#583712",
	// 		type : "dynamic",
	// 		density : 0
	// 	});
	//
	// 	var prismaticJoint = createPrismaticJoint(platform, {
	// 		"x" : 0.2820833921432495,
	// 		"y" : 0.13916654884815216
	// 	}, new b2Vec2(1, 0), 4);
	//
	// 	platform.beginContact = function(obj) {
	// 		if (obj.details.id === LEFT_WALL_ID) {
	// 			prismaticJoint.SetMotorSpeed(-4);
	// 		} else if (obj.details.id === RIGHT_WALL_ID) {
	// 			prismaticJoint.SetMotorSpeed(4);
	// 		}
	// 	};
	//
	// 	createSensors([{
	// 		"x" : 0.05000000074505806,
	// 		"y" : 0.15000000596046448
	// 	}, {
	// 		"x" : 0.25,
	// 		"y" : 0.42500001192092896
	// 	}, {
	// 		"x" : 0.875,
	// 		"y" : 0.699999988079071
	// 	}]);
	//
	// 	createDestination([{
	// 		"x" : 0.7250000238418579,
	// 		"y" : 0.30000001192092896
	// 	}, {
	// 		"x" : 0.7250000238418579,
	// 		"y" : 0.2750000059604645
	// 	}, {
	// 		"x" : 0.800000011920929,
	// 		"y" : 0.2750000059604645
	// 	}, {
	// 		"x" : 0.800000011920929,
	// 		"y" : 0.30000001192092896
	// 	}]);
	//
	// }
	//
	// function levelNine() {
	//
	// 	createStartPoint({
	// 		"x" : 0.9387500286102295,
	// 		"y" : 0.6687500476837158
	// 	}, 0.08514697104692459);
	//
	// 	createTerrain([{
	// 		outer : [{
	// 			"x" : 1.0391674041748047,
	// 			"y" : 0.6037503480911255
	// 		}, {
	// 			"x" : 0.5024996399879456,
	// 			"y" : 0.6287503242492676
	// 		}, {
	// 			"x" : 0.4008331894874573,
	// 			"y" : 0.398750364780426
	// 		}, {
	// 			"x" : 0.20000000298023224,
	// 			"y" : 0.4000000059604645
	// 		}, {
	// 			"x" : 0.22770798206329346,
	// 			"y" : 0.2039581835269928
	// 		}, {
	// 			"x" : 0.3402080237865448,
	// 			"y" : 0.04270815849304199
	// 		}, {
	// 			"x" : 0.22395800054073334,
	// 			"y" : 0.03145816922187805
	// 		}, {
	// 			"x" : 0.20000000298023224,
	// 			"y" : 0
	// 		}, {
	// 			"x" : 0.5658340454101562,
	// 			"y" : -0.0012495219707489014
	// 		}],
	// 		holes : []
	// 	}, {
	// 		outer : [{
	// 			"x" : 0.37010443210601807,
	// 			"y" : 0.5259372591972351
	// 		}, {
	// 			"x" : 0.36635440587997437,
	// 			"y" : 0.504062294960022
	// 		}, {
	// 			"x" : 0.396979421377182,
	// 			"y" : 0.5046873092651367
	// 		}, {
	// 			"x" : 0.3907294273376465,
	// 			"y" : 0.5465623140335083
	// 		}],
	// 		holes : []
	// 	}, {
	// 		outer : [{
	// 			"x" : 0.26385441422462463,
	// 			"y" : 0.5578122735023499
	// 		}, {
	// 			"x" : 0.2944794297218323,
	// 			"y" : 0.5315622687339783
	// 		}, {
	// 			"x" : 0.29322943091392517,
	// 			"y" : 0.5071873068809509
	// 		}, {
	// 			"x" : 0.26760441064834595,
	// 			"y" : 0.5065622925758362
	// 		}],
	// 		holes : []
	// 	}]);
	//
	// 	createWalls([[{
	// 		"x" : 0.1541665941476822,
	// 		"y" : 0.04333317279815674
	// 	}, {
	// 		"x" : 0.12874971330165863,
	// 		"y" : -0.0025001466274261475
	// 	}, {
	// 		"x" : 0.17874972522258759,
	// 		"y" : -0.0025001466274261475
	// 	}], [{
	// 		"x" : 0.6724997162818909,
	// 		"y" : 0.3587503135204315
	// 	}, {
	// 		"x" : 0.6500000953674316,
	// 		"y" : 0
	// 	}, {
	// 		"x" : 0.8750001192092896,
	// 		"y" : 0
	// 	}, {
	// 		"x" : 0.819166362285614,
	// 		"y" : 0.3537503182888031
	// 	}, {
	// 		"x" : 0.779167115688324,
	// 		"y" : 0.370417058467865
	// 	}, {
	// 		"x" : 0.8250001668930054,
	// 		"y" : 0.05000000447034836
	// 	}, {
	// 		"x" : 0.7000001668930054,
	// 		"y" : 0.05000000447034836
	// 	}, {
	// 		"x" : 0.7108330726623535,
	// 		"y" : 0.3704169690608978
	// 	}], [{
	// 		"x" : 0.2566669285297394,
	// 		"y" : 0.5041664242744446
	// 	}, {
	// 		"x" : 0.2870830297470093,
	// 		"y" : 0.4891665577888489
	// 	}, {
	// 		"x" : 0.37708303332328796,
	// 		"y" : 0.4891665577888489
	// 	}, {
	// 		"x" : 0.40666693449020386,
	// 		"y" : 0.5041664242744446
	// 	}], [{
	// 		"x" : 0.2752079963684082,
	// 		"y" : 0.02395816147327423
	// 	}, {
	// 		"x" : 0.25,
	// 		"y" : 0
	// 	}, {
	// 		"x" : 0.30000001192092896,
	// 		"y" : 0
	// 	}]]);
	//
	// 	createPolygon([{
	// 		"x" : 0.2499999850988388,
	// 		"y" : 0.45000001788139343
	// 	}, {
	// 		"x" : 0.22500000894069672,
	// 		"y" : 0.42500001192092896
	// 	}, {
	// 		"x" : 0.2499999850988388,
	// 		"y" : 0.4000000059604645
	// 	}, {
	// 		"x" : 0.2749999761581421,
	// 		"y" : 0.4000000059604645
	// 	}, {
	// 		"x" : 0.30000001192092896,
	// 		"y" : 0.42500001192092896
	// 	}, {
	// 		"x" : 0.2749999761581421,
	// 		"y" : 0.45000001788139343
	// 	}], {
	// 		color : "#342568",
	// 		type : "dynamic",
	// 		density : 8
	// 	});
	//
	// 	var board = createPolygon([{
	// 		"x" : 0.027499929070472717,
	// 		"y" : 0.04999983310699463
	// 	}, {
	// 		"x" : 0.02666659653186798,
	// 		"y" : 0.0958331748843193
	// 	}, {
	// 		"x" : 0.03833329677581787,
	// 		"y" : 0.059999845921993256
	// 	}, {
	// 		"x" : 0.06197904050350189,
	// 		"y" : 0.05989561975002289
	// 	}, {
	// 		"x" : 0.10197903215885162,
	// 		"y" : 0.07052062451839447
	// 	}, {
	// 		"x" : 0.25979161262512207,
	// 		"y" : 0.06520816683769226
	// 	}, {
	// 		"x" : 0.3035416007041931,
	// 		"y" : 0.07270816713571548
	// 	}, {
	// 		"x" : 0.2997916340827942,
	// 		"y" : 0.048958152532577515
	// 	}], {
	// 		color : "green",
	// 		type : "dynamic",
	// 		density : 0.5
	// 	});
	//
	// 	createRevoluteJoint(board, {
	// 		"x" : 0.17625020444393158,
	// 		"y" : 0.06166665256023407
	// 	});
	//
	// 	var hollow = createPolygon([{
	// 		"x" : 0.25822943449020386,
	// 		"y" : 0.5684372782707214
	// 	}, {
	// 		"x" : 0.3316669464111328,
	// 		"y" : 0.5291664600372314
	// 	}, {
	// 		"x" : 0.4313544034957886,
	// 		"y" : 0.582187294960022
	// 	}, {
	// 		"x" : 0.3316669464111328,
	// 		"y" : 0.5041664242744446
	// 	}], {
	// 		color : "green",
	// 		type : "dynamic",
	// 		density : 0.5
	// 	});
	//
	// 	createRevoluteJoint(hollow, {
	// 		"x" : 0.3318752348423004,
	// 		"y" : 0.5043748617172241
	// 	});
	//
	// 	createPushers([[{
	// 		"x" : 0.925000011920929,
	// 		"y" : 0
	// 	}, {
	// 		"x" : 0.925000011920929,
	// 		"y" : 0.02500000037252903
	// 	}, {
	// 		"x" : 0.9750000238418579,
	// 		"y" : 0.02500000037252903
	// 	}, {
	// 		"x" : 0.9750000238418579,
	// 		"y" : 0
	// 	}]]);
	//
	// 	createSensors([{
	// 		"x" : 0.949999988079071,
	// 		"y" : 0.125
	// 	}, {
	// 		"x" : 0.32500001788139343,
	// 		"y" : 0.574999988079071
	// 	}, {
	// 		"x" : 0.07500000298023224,
	// 		"y" : 0.42500001192092896
	// 	}]);
	//
	// 	createDestination([{
	// 		"x" : 0.7250000238418579,
	// 		"y" : 0.07500000298023224
	// 	}, {
	// 		"x" : 0.7250000238418579,
	// 		"y" : 0.05000000074505806
	// 	}, {
	// 		"x" : 0.800000011920929,
	// 		"y" : 0.05000000074505806
	// 	}, {
	// 		"x" : 0.800000011920929,
	// 		"y" : 0.07500000298023224
	// 	}]);
	//
	// }
	//
	// function createTerrain(data) {
	// 	var polys = [];
	// 	for ( var i in data) {
	// 		var obj = data[i];
	// 		polys.push({
	// 			outer : translatePoints(obj.outer),
	// 			holes : translateHoles(obj.holes)
	// 		});
	// 	}
	//
	// 	_terrain = new Body(_physics, {
	// 		type : "static",
	// 		shape : "terrain",
	// 		patternImg : _resources.snowPattern,
	// 		// color : "#996633",
	// 		terrainPolys : polys
	// 	});
	//
	// }
	//
	// function createBouncers(data, restitution) {
	// 	for ( var i in data) {
	// 		var points = data[i];
	// 		createPolygon(points, {
	// 			color : "pink",
	// 			restitution : 1.2
	// 		});
	// 	}
	// }
	//
	// function createWalls(data) {
	// 	for ( var i in data) {
	// 		var points = data[i];
	// 		createPolygon(points, {
	// 			color : "#C4460D",
	// 			zIndex : 1
	// 		});
	// 	}
	// }
	//
	// function createPushers(data) {
	// 	for ( var i in data) {
	// 		var points = data[i];
	// 		var pusher = createPolygon(points, {
	// 			color : "red"
	// 		});
	//
	// 		pusher.beginContact = function(obj) {
	// 			if (obj.details.id === BALL_ID) {
	// 				var body = obj.body;
	// 				body.ApplyImpulse(new b2Vec2(0, -50), body.GetWorldCenter());
	// 			}
	// 		};
	// 	}
	//
	// }
	//
	// function createStartPoint(point, r) {
	//
	// 	var pos = translatePoint(point);
	//
	// 	new Body(_physics, {
	// 		id : START_POINT_ID,
	// 		type : "static",
	// 		color : "rgba(242,39,39,0.3)",
	// 		shape : "circle",
	// 		x : pos.x,
	// 		y : pos.y,
	// 		radius : r * _canvasW,
	// 		isSensor : true
	// 	});
	// }
	//
	// function createPolygon(points, details) {
	//
	// 	var polyDetails = {
	// 		type : "static",
	// 		shape : "polygon",
	// 		color : "e5e5e5",
	// 		zIndex : 0,
	// 		points : translatePoints(points),
	// 	};
	//
	// 	for ( var i in details) {
	// 		polyDetails[i] = details[i];
	// 	}
	//
	// 	return new Body(_physics, polyDetails);
	// }
	//
	// function createSensors(points) {
	// 	var sensorPoints = translatePoints(points);
	//
	// 	for ( var i in sensorPoints) {
	// 		var pos = sensorPoints[i];
	// 		var sensor = new Body(_physics, {
	// 			type : "static",
	// 			image : _resources.bunnyImg,
	// 			shape : "circle",
	// 			zIndex : 1,
	// 			x : pos.x,
	// 			y : pos.y,
	// 			radius : BUNNY_R,
	// 			height : BUNNY_R * 2,
	// 			width : BUNNY_R * 2,
	// 			isSensor : true
	// 		});
	//
	// 		sensor.beginContact = function(obj) {
	// 			if (obj.details.id === BALL_ID) {
	// 				this.details.dead = true;
	// 			}
	// 		};
	// 	}
	// }
	//
	// function createDestination(points) {
	// 	var finishingPoint = new Body(_physics, {
	// 		type : "static",
	// 		shape : "polygon",
	// 		color : "yellow",
	// 		isSensor : true,
	// 		zIndex : 1,
	// 		points : translatePoints(points),
	// 	});
	//
	// 	finishingPoint.beginContact = function(obj) {
	// 		$('#level-dialog').dialog("open");
	// 		finishingPoint.beginContact = undefined;
	// 	};
	// }
	//
	// function createRevoluteJoint(obj, point, motorSpeed) {
	// 	var revoluteJointDef = new b2RevoluteJointDef();
	//
	// 	var anchor = translatePoint({
	// 		"x" : point.x,
	// 		"y" : point.y
	// 	});
	//
	// 	revoluteJointDef.Initialize(_physics.world.GetGroundBody(), obj.body,
	// 			new b2Vec2(anchor.x / _physics.scale, anchor.y / _physics.scale));
	//
	// 	revoluteJointDef.maxMotorTorque = 5.0;
	// 	revoluteJointDef.motorSpeed = motorSpeed || 0;
	// 	revoluteJointDef.enableMotor = true;
	//
	// 	return _physics.world.CreateJoint(revoluteJointDef);
	// }
	//
	// function createPrismaticJoint(obj, point, axis, speed) {
	// 	var prismaticJointDef = new b2PrismaticJointDef();
	//
	// 	var anchor = translatePoint({
	// 		"x" : point.x,
	// 		"y" : point.y
	// 	});
	//
	// 	prismaticJointDef.Initialize(obj.body, _physics.world.GetGroundBody(),
	// 			new b2Vec2(anchor.x / _physics.scale, anchor.y / _physics.scale),
	// 			axis);
	//
	// 	prismaticJointDef.maxMotorForce = 10.0;
	// 	prismaticJointDef.motorSpeed = speed || 0;
	// 	prismaticJointDef.enableMotor = true;
	//
	// 	return _physics.world.CreateJoint(prismaticJointDef);
	// }
	//
	// function translateHoles(shapes) {
	// 	var translated = [];
	// 	for ( var i in shapes) {
	//
	// 		// Holes are CCW
	// 		translated.push(translatePoints(shapes[i]).reverse());
	// 	}
	// 	return translated;
	// }
	//
	// function translatePoints(points) {
	// 	var translated = [];
	// 	for ( var i in points) {
	// 		translated.push(translatePoint(points[i]));
	// 	}
	// 	return translated;
	// }
	//
	// function translatePoint(point) {
	// 	return {
	// 		x : point.x * _canvasW,
	// 		y : _canvasH - point.y * _canvasW
	// 	};
	// }

/***/ },

/***/ 180:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/angry-bird-30x30.cd1f16792f2aef034e094249281d9042.png";

/***/ },

/***/ 181:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/bunny-40x40.7e0856e598081237e6a06ec992a38da8.png";

/***/ },

/***/ 182:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/snow-textures-5.230efbd02543beac94672cd23fc75cb3.jpg";

/***/ }

});


/** WEBPACK FOOTER **
 ** app.031b23808b9e9968b0f9.js
 **/